import { PlatformLocation, Location } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpResponse } from '@angular/common/http';
import { EventEmitter, Injectable, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription, throwError as observableThrowError, timer } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import * as Sentry from '@sentry/browser';

import {
    BookingsModel,
    CashBoxModel,
    CashBoxModelTerminal,
    CashOutModelTerminal,
    CasinoModel,
    CategoriesModel,
    CustomerBetsModel,
    CustomerTransactionModel,
    FixtureModel,
    LandingModel,
    LastPayoutModel,
    LiveCardModel,
    LiveExtraOdds,
    LiveFixture,
    MatchModel,
    OddTypeModel,
    OpenSlipModel,
    PageModel,
    ResultModel,
    SideBannerModel,
    SlipModel,
    SportsModel,
    TournamentsModel,
    TransactionTypeModel,
} from '../../categories/categories';
import { CoreService } from '../../services/core.service';
import { SportHeader, TerminalCategoriesModel, TerminalTournamentsModel } from '../../sportheader/sportheader';
import { OddModel } from '../tournaments';

import { RESPONSE_AS_TEXT_X_WWW } from '~/constant/requests.constant';
import { DATA_INITIALIZER, SPORTS_TYPE } from '~/constant/sports.constant';
import { translatePipe, translationHelper } from '~/helpers/translation.helper';
import { uiHelper } from '~/helpers/ui.helper';
import { lg } from '~/modules/colorLog';
import { ElectronService } from 'ngx-electron';
import { WebWorkerService } from '../../../../modules/workers/web-worker.service';

import { environment, socketURL } from '@env/environment';
import { OddConstant } from '~/constant/odd.constant';
import { Local } from 'protractor/built/driverProviders';
import { Title } from '@angular/platform-browser';

declare let $;
let langCode;
let langId;
let timeZone;

declare let PageId;
declare let langs;
declare let TranslateOnlyText;
declare let SetLanguage: any;
declare let RenderMatch: any;
declare let JsBarcode: any;
declare let translationobj: any;
declare let _sendChromeMessage: any;
declare let betaluxBr;

// TEST DEVRIM
declare let Print_Ticket: any;

declare let Print_Cashout_Ticket: any;
declare let Print_LastSlipTicket: any;
declare let Print_SlipDuplicate: any;
declare let Print_LastPayoutTicket: any;
declare let Print_LastPayout_Detail_Ticket: any;

declare let Print_Credit_Voucher_Ticket: any;

const find = '/';
const re = new RegExp(find, 'g');

@Injectable()
export class TournamentsService {
    public printDuplicateSlip_List = [];

    public _ScoreboxList;
    public _ScoreboxList_Old;
    public _ScoreboxList_New;

    // Open Bets
    public openBets_subClientCO: Subscription;
    // Open Bets

    public slipdetail_subClientCO: Subscription;
    public cashoutdetail_subClientCO: Subscription;

    public BettingSlip_Clicked_Button_Submit_Bet = false;

    public SlipDetailTerminal_Completed = true;
    public CashoutDetailTerminal_Completed = true;
    public CashoutDetailTerminalValue_Completed = true;

    // Socket reconnection properties
    private reconnectAttempts = 0;
    private maxReconnectAttempts = 10;
    private reconnectDelay = 1000; // Start with 1 second
    private maxReconnectDelay = 30000; // Max 30 seconds
    private reconnectTimeout: any;
    private isReconnecting = false;
    private connectionStatus = 'disconnected'; // 'connected', 'disconnected', 'reconnecting'

    // Message Modal
    public Message_Modal_Header = '';
    public Message_Modal_Desc = '';

    // Message Modal

    // _liveextraodds : LiveExtraOdds[] =[];
    public rsbCounterVisible = 0;
    public golpopuplist = [];
    public isExpandedObservable = [];
    public extraODDs = [];
    public KKkkkkkkkk = [];
    public _liveTopScreenList;
    public _allscreenheader: number;
    public _livebetfooterDayisActive = false;
    public _upComingTopScreenList;
    public _liveisExpanded;
    public rbsSetIntervalClear;
    public rbsSetIntervalClearGreen;
    public Terminal_ID = '';
    public Terminal_Version = '';
    public rbscounterValue = 11;
    public rbscounterValueGreen = 11;
    public obj_bettingslip_system_modal: any;
    public customerPasswordMessageVisible = 0;
    public Page_Window_Height = 0;
    public Page_Window_Width = 0;

    public connectionEstablished: EventEmitter<boolean>;
    public connectionExists: boolean;

    public messageReceived: EventEmitter<any>;

    // SlipDetail - Cashout - Timers

    public timer_slipdetail;

    public timer_cashoutvalue;

    // SlipDetail - Cashout - Timers

    public _terminalcurrenttime;
    public _oldhalftimeList;
    public _halftimeList;
    public _liveFixtureList;
    public _liveFixtureListFiltered;
    public _OLDliveFixtureListFiltered;
    public _terminalnews;
    public _liveFixtureListSoccer;
    public _liveoldSoccer;

    public _liveFixtureListTennis;
    public _liveoldTennis;
    public rsbSlipId;

    public _liveFixtureListHandball;
    public _liveoldHandball;
    public readPayoutErrorVisible = 0;
    public readPayoutError;
    public _liveFixtureListIceHockey;
    public _liveoldIceHockey;
    // Open Bet Ayarlamaları
    public openbetVisible = 1;
    public openbetActive = 1;
    public showOpenBets = 0;
    public customerTransactionDate = '7' + ' ' + this.translateStaticWord('Day');
    //
    public _liveFixtureListBasketball;
    public _liveoldBasketball;

    public cashoutmessageTerminal: string;
    public cardCustomerId: string;
    public cashoutMessageTerminalActive = 0;
    public payoutPayConfirmButton = 0;
    public _liveeventodds;
    public _cardList;
    public matchtimeScore: string;
    public activeSport: string;
    public settingPasssword;
    public currentServerTime;
    public fixtureTypeSelect = 'standart';
    public changePasswordMessage: string;
    public isCashOutActive: boolean;
    public isChangePassword: boolean;
    public registerMessage: string;
    public isSaveRegister: boolean;
    public depositCepBankMessage: string;
    public depositAsiaHawalaMessage: string;
    public depositZainCashMessage: string;
    public depositFastPayMessage: string;
    public depositCoinBaseMessage: string;
    public personalDetailMessage: string;
    public customerDocumentCreateMessage: string;
    public selfLimitsMessage: string;
    public accountLockMessage: string;
    public IsSavePersonalDetail: boolean;
    public WebMoneyError: boolean;
    public IsSaveCustomerSelfLimits: boolean;
    public IsAccountLockCustomer: boolean;
    public comboCountry: number;
    public uploadFiles;
    public accountLock: IAccountLock;
    public customerOne: ICustomerOne;
    public selfLimits: ISelfLimits;
    public withdrawMessage: string;
    public cashOutMessage: string;
    public payOutMessage: string;
    public isTransfer: boolean;
    public isWithdrawMessage = false;
    public isCashOut: boolean;
    public isPayOut: boolean;
    public data = '';
    public resultSportId: string;
    public match: any;
    public systemSlips = [];
    public livematch: any;
    public responseString: string;
    public isMatchDetail = false;
    public isWithdrawDetail = false;
    public isDepositDetail = false;
    public depositMethod;
    public withdrawMethod;
    public isLiveMatchDetail = false;
    public fixtureList: FixtureModel[] = [];
    public selectedOdds: OddModel[] = [];
    public slipCurrents = [];
    public idforcahsout: any;
    public cashOutList = [];
    public activeSortTypeOfLive = 'standart';

    public topLeaguesModalList = [];

    // preMatch variables
    public terminalFixtureList = [];
    public terminalOddList = [];
    public terminalSearchList = [];

    public customerTransactionList = [];
    public CustomerBetsList = [];
    public openSlipList = [];
    public terminalSportResult = [];
    public terminalAllUpcomingList = [];
    public terminalLiveFixtureList = [];

    public liveOddsList = {};
    public liveOddsList_OLD = {};

    public terminalmatchOddsList = [];
    public payoutModalList = [];
    public terminalResultList = [];
    public settingPasswordValue;
    public confirmTicketCounter = 3;
    public confirmMessageActive = 0;
    public confirmTicketCounterPayout = 3;
    public confirmMessageActivePayout = 0;
    public CalculatorValueString = '5';
    public CalculatorValue = 5;
    public printSlipList = [];
    public printSlip_Cashout_List = [];
    public printLastSlip_List = [];
    public printLastPayout_List = [];
    public settingPasswordError = '';
    public BettingSlip_Menu_SlipType = 1;
    public Sportbet_SportId = 1;
    public Livebet_SportId = 1;
    public SettingPasswordErrorVisible = 0;
    // Credit Voucher
    public Credit_Voucher_TicketPassword: string;
    public Credit_Voucher_Terminal: string;
    public Credit_Voucher_Affiliate: string;
    public Credit_Voucher_TicketNr: string;
    public Credit_Voucher_Amount: string;
    public Credit_Voucher_CreatedDate: string;
    public LSBranchId: string;
    public LSParentBranchId: string;
    public LSTicketDate: string;

    public LSTicketNo: string;
    public LSAmount: string;
    public LSTicketPassword: string;
    // Credit Voucher
    public SignInFocusControl;
    public ReadPayoutSlipFocusControl;
    public KeyboardValue = '';
    public UserPasswordValue = '';
    public CustomerPasswordMessage = '';
    public UserNameValue = '';
    public printSlipDetailList = [];
    public printSlip_SlipId: string;
    public confirmTicketSetIntervalClear;
    public confirmTicketSetIntervalClearPayout;
    public BettingSlip_PrintBet_Barcode = '';

    // Slip Detail - Cashout => Control SlipId = 92507
    public SlipCashOutSlipNumber = 0;
    public SlipNumberControl = 0;

    public sportCountryCategoryName;
    public sportCountryCategoryNameVisible = 0;
    public sportTopleaguesTournamentName;
    public sportTopleaguesTournamentNameVisible = 0;
    public CashOutPayAcceptValue = 1;
    public PayoutNow = '';
    public PayoutPayAcceptValue = 1;

    public TerminalSearchValue = '';
    public SystemModalButtonValue: string = this.translateStaticWord('System_Combinations');
    public SlipCashOutSlipPassword = 2;
    public SlipCashOutSlipPasswordControl = 5;
    public SlipDetailList_Terminal = [];
    public CashoutDetailList_Terminal = [];
    public terminalFixtureListByCategories = [];
    public cashOutDetailList = [];
    public cashOutValueList_Terminal = [];
    public SystemModalButtonValueArray = [];
    public cashOutSendVisibilty: boolean;
    public amount = '5';
    public slipType = '1';
    public cashOutButtonClick = 0;
    public payOutButtonClick = 0;
    // customerLoginFirstDimmer: string = "";
    public slipCurrentDimmer = '';
    public registerDimmer = '';
    public changePasswordDimmer = '';
    public withdrawDimmer = '';
    public personalDetailDimmer = '';
    public selfLimitsDimmer = '';
    public accountLockDimmer = '';
    public depositCepBankDimmer = '';
    public depositAsiaHawalaDimmer = '';
    public depositZainCashDimmer = '';
    public depositFastPayDimmer = '';
    public depositCoinBaseDimmer = '';
    public isDepositCepBankForm: boolean;
    public isDepositAsiaHawalaForm: boolean;
    public isDepositZainCashForm: boolean;
    public isDepositFastPayForm: boolean;
    public isDepositCoinBaseForm: boolean;
    public PayoutSlipNumber = '';
    public PayoutSlipPassword = '';
    public init: boolean;
    public messageType = '';
    public message = '';
    public popularTournamentList = [];
    public notpopularTournamentList = [];
    public closeCahBoxList = [];
    public checkCashBoxList = [];
    public customerPayoutPassword = '';
    public customertransactionButtonControl = 1;
    public PayoutPayConfirm = '';
    public PayoutPayConfirmVisible = 0;
    public closeCashBoxBranch: CashBoxModel = {
        Affiliate: '',
        AffiliateID: '',
        Cashier: '',
        CashierID: '',
        Period: '',
    };
    public checkCashBoxBranch: CashBoxModel = {
        Affiliate: '',
        AffiliateID: '',
        Cashier: '',
        CashierID: '',
        Period: '',
    };

    public liveFixtureListSearch = [];
    public upcomingFixtureListSearch = [];
    public fixturetourId = 0;
    public fixturecatId = 0;
    public fixturedate = '';
    public fixturesportId = 1;
    public notpopularListVisible = 1;
    public subMenuType = 0;
    public sportDayFilter = 360;
    public searchResponse: FixtureModel[] = [];
    public highlightObservable: Observable<FixtureModel[]>;
    public liveUpcomingObservable: Observable<FixtureModel[]>;
    public liveCardsObservable: LiveCardModel[];
    public lastMinuteObservable: Observable<FixtureModel[]>;
    public todayObservable: Observable<FixtureModel[]>;
    public sideBannerObservable: Observable<SideBannerModel[]>;
    public cashOutSlipObservable: Observable<SlipModel[]>;
    public cashOutslipDetailObservable: Observable<SlipModel[]>;
    // serverTimeObservable: Observable<ServerTimeModel[]>;
    public pageObservable: Observable<PageModel[]>;
    public favouriteObservable = [];
    public favTodayObservable = [];
    public isClicked = [];
    public tax = 0;
    public isCasinoLoadingActive: string;
    public slipAmount: SlipAmount = {
        MaxGain: '0',
        ToPay: '0',
        TotalRate: '0',
        NumberOfBets: '0',
        AmountPerBet: '0',
    };

    public translations: any;

    //

    public sportEnum = 1;

    @Output()
    public CurrentSlipReceived: EventEmitter<number> = new EventEmitter<number>();
    public oddClickReceived: EventEmitter<number> = new EventEmitter<number>();

    // Eğer bu kontrol olmazsa devamlı girip sistemi kitliyor.
    public flag_control_getsportfixturesearch = 0;

    // Eğer bu kontrol olmazsa devamlı girip sistemi kitliyor.
    public flag_control_getcurrentslip = 0;

    // Eğer bu kontrol olmazsa devamlı girip sistemi kitliyor.
    public flag_control_refreshcurrentslip = 0;

    // Eğer bu kontrol olmazsa devamlı girip sistemi kitliyor.
    public flag_control_changeslipamount = 0;
    //Max Event Count
    public max_event_count = 30;
    public SERVICE_STARTUP: EventEmitter<any> = new EventEmitter();
    public TicketKeyboardModalIsActive = false;
    intervalSportFixture;
    counterFixtureRefresher = 0;
    private timeropenbets;
    private proxy: any;
    private proxyName = 'liveBetsHub';
    private connection: any;
    private apisUrl = '/API/';
    // private cashoutApisUrl = 'https://coapiterminal.bet3000.de/API/';
    /*
    private cashoutApisUrl =
        environment.systemName == 'bet3000'
            ? environment.production === true
                ? 'https://coapiterminal.bet3000.de/API/'
                : '/API/'
            : '/API/';
*/
    private cashoutApisUrl = '/API/';
    private currentListenerData = {
        sportEnum: -1,
        tournament: -1,
    };

    public isMultiWay = false;

    constructor(
        private http: HttpClient,
        private coreService: CoreService,
        public router: Router,
        private platformLocation: PlatformLocation,
        private location: Location,
        private _uiHelper: uiHelper,
        private _translate: translationHelper,
        private _ElectronService: ElectronService,
        private _webWorkerService: WebWorkerService,
        private _OddConstant: OddConstant,
        private titleService: Title,
    ) {
        this.SERVICE_STARTUP.subscribe(() => {
            langCode = this._translate.LANGCODE;
            langId = this._translate.LANGID;
            timeZone = this._translate.TIMEZONE;

            this.coreService.setCurrentTournamentsService(this);

            this.connectionEstablished = new EventEmitter<boolean>();
            this.connectionExists = false;

            this.messageReceived = new EventEmitter<any>();

            this.connectionExists = false;
            // create hub connection

            // @ts-ignore
            if (socketURL != '')
                this.connection = $.hubConnection(socketURL, {
                    qs: { langId: langId },
                });
            else
                this.connection = $.hubConnection((this.platformLocation as any).location.origin, {
                    qs: { langId: langId },
                });
            // this.connection = $.hubConnection('http://localhost:61296');
            //this.connection = $.hubConnection((this.platformLocation as any).location.origin);

            //this.connection = $.hubConnection((this.platformLocation as any).location.origin);
            //console.log("hubconnection", (this.platformLocation as any).location.origin);
            // create new proxy as name already given in top
            this.proxy = this.connection.createHubProxy(this.proxyName, {
                qs: { langId: langId },
            });

            // register on server events
            this.registerOnServerEvents();

            if (
                this._uiHelper.terminalConfig.IsLiveOn == undefined ||
                this._uiHelper.terminalConfig.IsLiveOn === true
            ) {
                // call the connecion start method to start the connection to send and receive events.
                this.startConnection();
                // this.updateConnection();
            }

            this._uiHelper.terminalConfigListener.subscribe(e => {
                if (this._uiHelper.terminalConfig.IsLiveOn === false) {
                    this.connection.stop();
                    this._liveFixtureList = [];
                    this._OLDliveFixtureListFiltered = [];
                }

                // 03.03.2022 Eklendi
                if (this._uiHelper.terminalConfig.TemporaryBet === false) {
                    this.coreService.customerUser.IsAnonymousBet = 0;
                }
            });

            this.connection.disconnected(() => {
                this.connectionStatus = 'disconnected';
                this.handleDisconnection();
            });

            this.connection.reconnecting(() => {
                this.connectionStatus = 'reconnecting';
            });

            this.connection.reconnected(() => {
                this.connectionStatus = 'connected';
                this.reconnectAttempts = 0;
                this.reconnectDelay = 1000;
                this.isReconnecting = false;
            });

            // Translations
            this.translations = translationobj;

            this.fixturesportId = this._uiHelper.sportEnum;
            this.sportEnum = this._uiHelper.sportEnum;
            this.getSportFixture('initial');
            this._uiHelper.sportEnum_Listener.subscribe(x => {
                //lg('SPORT TYPE CHANGE', x);
                this.fixturesportId = x;
                this.sportEnum = x;
                this.getSportFixture('SPORT TYPE CHANGE');

                const liveFilter = {
                    _data: this._liveFixtureList,
                    fixturetourId: this.fixturetourId,
                    sportEnum: this.sportEnum,
                    sportsType: SPORTS_TYPE(),
                    _olddata: this._OLDliveFixtureListFiltered,
                };
                const workerLiveData = this._webWorkerService
                    .run(this.rebuildLiveData, liveFilter)
                    .then((result: any) => {
                        //console.log("workerLiveData", result);
                        this._uiHelper.setLiveFilteredData(result.retData);

                        this._uiHelper.SetLiveGoalListData(result.liveGoalListData);

                        this._liveFixtureListFiltered = result.retData;

                        result.sportsType && DATA_INITIALIZER(result.sportsType).then();
                    })
                    .catch(err => {
                        console.log('workerLiveData error', err);
                    });
                //this._liveFixtureListFiltered = this.rebuildLiveData(this._liveFixtureList);
            });

            this.fixturetourId = this._uiHelper.tournamentType;

            this._uiHelper.tournamentType_Listener.subscribe(x => {
                if (this.currentListenerData.tournament != x) {
                    this.fixturetourId = x;
                    //this._liveFixtureListFiltered = this.rebuildLiveData(this._liveFixtureList);

                    const liveFilter = {
                        _data: this._liveFixtureList,
                        fixturetourId: this.fixturetourId,
                        sportEnum: this.sportEnum,
                        sportsType: SPORTS_TYPE(),
                        _olddata: this._OLDliveFixtureListFiltered,
                    };
                    const workerLiveData = this._webWorkerService
                        .run(this.rebuildLiveData, liveFilter)
                        .then((result: any) => {
                            //console.log("workerLiveData", result);
                            this._uiHelper.setLiveFilteredData(result.retData);
                            this._uiHelper.SetLiveGoalListData(result.liveGoalListData);

                            this._liveFixtureListFiltered = result.retData;

                            result.sportsType && DATA_INITIALIZER(result.sportsType).then();
                        })
                        .catch(err => {
                            console.log('workerLiveData error', err);
                        });

                    // Trigger when tournament has been changed.
                    this.getSportFixture('tournament Type change');

                    this.currentListenerData.tournament = x;
                }
            });

            this._uiHelper.getSportFixtureListener.subscribe(x => {
                if (this.currentListenerData.sportEnum != x) {
                    this.getSportFixture('sportFixture listener');

                    this.currentListenerData.sportEnum = x;
                }
            });
        });
    }

    public ChangeLanguage() {
        this.translations = translationobj;
    }

    public startConnection(): void {
        this.connectionStatus = 'reconnecting';
        this.connection
            .start()
            .done((data: any) => {
                // console.log('Now connected ' + data.transport.name + ', connection ID= ' + data.id);
                this.connectionEstablished.emit(true);
                this.connectionExists = true;
                this.connectionStatus = 'connected';
                this.reconnectAttempts = 0;
                this.reconnectDelay = 1000;
                this.isReconnecting = false;

                //this.proxy.invoke('getCurrentTime');
                this.proxy.invoke('read');
                //this.proxy.invoke('firstHalf');
                //this.proxy.invoke('liveOdds');
                //this.proxy.invoke('cards');
                //this.proxy.invoke('terminalscorebox');
                //this.proxy.invoke('topscreenLive');
                //this.proxy.invoke('topscreenUpComing');
                //this.proxy.invoke('isExpanded');
                //this.proxy.invoke('AddGroup', langId);

                //console.log("Second screen is active?",this._uiHelper.SecondScreenIsActive);

                // if (this._uiHelper.SecondScreenIsActive) {
                //     this.addscoreboxgroup(langId);
                // } else {
                //     this.addgroup(langId);
                // }
                this.addgroup(langId);

                // console.log("removeGroup", langId);
                // this.proxy.invoke('RemoveGroup', langId);
            })
            .fail((error: any) => {
                console.log('Could not connect ' + error);
                this.connectionEstablished.emit(false);
                this.connectionStatus = 'disconnected';
                this.handleConnectionFailure();
            });
    }

    public addgroup(newlangId) {
        if (this.connectionExists) this.proxy.invoke('AddGroup', newlangId);
    }

    public addscoreboxgroup(newlangId) {
        if (this.connectionExists) this.proxy.invoke('AddScoreBoxGroup', newlangId);
    }

    public removeGroup(_langId) {
        if (this.connectionExists) this.proxy.invoke('RemoveGroup', _langId);
    }

    // Enhanced socket reconnection methods
    private handleDisconnection(): void {
        if (this.isReconnecting || this._uiHelper.terminalConfig.IsLiveOn === false) {
            return;
        }

        this.isReconnecting = true;
        this.scheduleReconnect();
    }

    private handleConnectionFailure(): void {
        if (this.isReconnecting || this._uiHelper.terminalConfig.IsLiveOn === false) {
            return;
        }

        this.isReconnecting = true;
        this.scheduleReconnect();
    }

    private scheduleReconnect(): void {
        if (this.reconnectAttempts >= this.maxReconnectAttempts) {
            this.isReconnecting = false;
            this.showConnectionStatus('Socket bağlantısı kurulamadı. Lütfen sayfayı yenileyin.', 'error');
            return;
        }

        this.reconnectAttempts++;
        const delay = Math.min(this.reconnectDelay * Math.pow(2, this.reconnectAttempts - 1), this.maxReconnectDelay);

        this.reconnectTimeout = setTimeout(() => {
            if (this._uiHelper.terminalConfig.IsLiveOn === true) {
                this.startConnection();
            }
        }, delay);
    }

    private showConnectionStatus(message: string, type: 'success' | 'warning' | 'error' | 'info'): void {
        // UI'da göster (mevcut message sistemini kullan)
        if (type === 'error') {
            this.messageType = 'errorSystemMessage';
            this.message = message;
        } else if (type === 'success') {
            this.messageType = 'successMessage';
            this.message = message;
        } else {
            // Info ve warning için geçici mesaj göster
            this.messageType = 'errorMessage';
            this.message = message;
            // 3 saniye sonra temizle
            setTimeout(() => {
                if (this.message === message) {
                    this.messageType = '';
                    this.message = '';
                }
            }, 3000);
        }
    }

    public getConnectionStatus(): string {
        return this.connectionStatus;
    }

    public isSocketConnected(): boolean {
        return this.connectionStatus === 'connected' && this.connectionExists;
    }

    public forceReconnect(): void {
        if (this.reconnectTimeout) {
            clearTimeout(this.reconnectTimeout);
        }
        this.reconnectAttempts = 0;
        this.reconnectDelay = 1000;
        this.isReconnecting = false;
        this.startConnection();
    }

    public rebuildLiveData = e => {
        if (e == undefined) return [];
        const _data = e._data;
        const fixturetourId = e.fixturetourId;
        const sportEnum = e.sportEnum;
        let sportsType = e.sportsType;
        const collectLiveCount: object = {};
        const _slipCurrents = e._slipCurrents;

        if (sportsType) {
            e.sportsType.forEach(i => {
                collectLiveCount[i.name] = 0;
            });
        }
        const _olddata = e._olddata;
        let liveGoalListData = []; // Header Live Goal List
        if (!_data) {
            return [];
        }
        let retData = _data;

        if (fixturetourId !== 0) {
            retData = retData.filter(f => f.TournamentID === fixturetourId);
        }
        const sportTypeItem = sportsType.filter(x => x.EnumSportType === sportEnum);
        retData = retData.filter(f => f.SportNameOriginal === sportTypeItem[0].name);

        if (_data != undefined) {
            _data.forEach(x => {
                if (_olddata != undefined) {
                    // ScoreBox ( SecondScreen ) Ekranında BetradarMatchId 0 geliyor. Bundan dolayı bu Kontrol eklendi
                    let _oldMATCHITEM;
                    if (x.BetradarMatchId != 0) {
                        _oldMATCHITEM = _olddata.find(s => s.BetradarMatchId == x.BetradarMatchId);
                    } else {
                        _oldMATCHITEM = _olddata.find(s => s.MatchId == x.MatchId);
                    }

                    if (_oldMATCHITEM != undefined) {
                        // GOAL ANIMATION
                        if (x.Score != _oldMATCHITEM.Score) {
                            x['goalcss'] = 'goal';
                            //console.warn("GOOOOAAALLAL"+ x.HomeTeam);
                        }

                        if (x.SportNameOriginal == 'Soccer') {
                            if (x.HomeScore != _oldMATCHITEM.HomeScore && x.HomeScore != '0') {
                                liveGoalListData.push({
                                    homeScore: x.HomeScore,
                                    awayScore: x.AwayScore,
                                    homeTeam: x.HomeTeam,
                                    awayTeam: x.AwayTeam,
                                    homeGoal: true,
                                    awayGoal: false,
                                    visible: false,
                                });
                                x['homegoalcss'] = 'teamgoal';
                                //console.warn("Team 1 Goal" + x.HomeTeam);
                            }

                            if (x.AwayScore != _oldMATCHITEM.AwayScore && x.AwayScore != '0') {
                                // Header da Goal Animasyonu için
                                liveGoalListData.push({
                                    homeScore: x.HomeScore,
                                    awayScore: x.AwayScore,
                                    homeTeam: x.HomeTeam,
                                    awayTeam: x.AwayTeam,
                                    homeGoal: false,
                                    awayGoal: true,
                                    visible: false,
                                });
                                // Match Row da Goal Animasyonu için
                                x['awaygoalcss'] = 'teamgoal';
                                //console.warn("Team 2 Goal" + x.HomeTeam);
                            }
                        }
                    }

                    if (_slipCurrents != null && _slipCurrents.length > 0) {
                        let _slipEvent;
                        if (x.BetradarMatchId != 0) {
                            _slipEvent = _slipCurrents.find(s => s.MatchId == x.BetradarMatchId);
                        }
                        if (_slipEvent != undefined && _slipEvent.liveData != undefined) {
                            _slipEvent.liveData.TimeStatu = x.TimeStatu;
                            _slipEvent.liveData.Score = x.Score;
                            _slipEvent.liveData.MatchTime = x.MatchTime;
                        }
                    }
                }

                collectLiveCount[x.SportNameOriginal]++;
            });

            if (sportsType) {
                sportsType = sportsType.map(item => ({
                    ...item,
                    sportEventCount: collectLiveCount[item.name],
                }));
            }
        }

        // Calculate live matches count by sports.

        return { retData: retData, liveGoalListData: liveGoalListData, sportsType, _slipCurrents: _slipCurrents };
        //this._uiHelper.setLiveFilteredData(retData);
        // return retData;
    };

    public rebuildLiveOdds = e => {
        let _oddData = e._oddData;
        let OLD_oddData = e.OLD_oddData;
        let forbiddenOddTypes = e.forbiddenOddTypes;
        const OKeys_oddData = Object.keys(_oddData);
        const _slipCurrents = e._slipCurrents;
        const returnedItem = {};
        let _flagOddChange = false;
        //console.time('odd-process');
        if (OKeys_oddData.length > 0 && Object.keys(OLD_oddData).length > 0) {
            OKeys_oddData.forEach(byOddType => {
                // Safely access for nested arrays.
                const idx = (p, o) => p.reduce((xs, x) => (xs && xs[x] ? xs[x] : null), o);
                if (forbiddenOddTypes.includes(parseInt(byOddType.split('/')[1]))) {
                } else {
                    returnedItem[byOddType] = _oddData[byOddType].map((oddItem, index) => {
                        if (idx([byOddType, index], OLD_oddData)) {
                            oddItem['OddValueStatus'] =
                                oddItem.OddValue > idx([byOddType, index, 'OddValue'], OLD_oddData)
                                    ? 'up'
                                    : oddItem.OddValue < idx([byOddType, index, 'OddValue'], OLD_oddData)
                                    ? 'down'
                                    : '-';
                        }

                        if (_slipCurrents != null && _slipCurrents.length > 0) {
                            const _slipEvent = _slipCurrents.find(s => s.OddId1 == oddItem['OddId']);
                            if (_slipEvent != undefined) {
                                if (_slipEvent.OddValue1 != oddItem['OddValue']) {
                                    _flagOddChange = true;
                                }
                                //Burada istenirse kuponda yeşil kırmızı efekti verilebilir
                                _slipEvent.OddValue1 = oddItem['OddValue'];
                                _slipEvent.Visibility = oddItem['Visibility'];

                                //if (oddItem['BetStatus'] == "block") {
                                //  _slipEvent.Visibility = 'hidden';
                                //}
                            }
                        }

                        return oddItem;
                    });
                }
            });

            //console.timeEnd('odd-process');
            return { _oddData: returnedItem, _slipCurrents: _slipCurrents, _flagOddChange: _flagOddChange };
        } else {
            return { _oddData: _oddData, _slipCurrents: _slipCurrents, _flagOddChange: _flagOddChange };
        }
    };

    public getSportFixture(source) {
        console.log('GetSportFixture', source);
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        if (this.fixturedate === '') {
            // todo temp fix for date
            this.fixturedate = new Date()
                .toISOString()
                .split('T')[0]
                .replace(/-/g, '/')
                .toString();
            this.fixturedate = ` ${this.fixturedate.split('/')[2]}-${this.fixturedate.split('/')[1]}-${
                this.fixturedate.split('/')[0]
            }`;
            // console.log(this.fixturedate, this.fixturedate.replace(re, '-'));
        } else {
            this.fixturedate = this.fixturedate.replace(re, '-');
        }
        //Update Pre Fixture
        if (this.intervalSportFixture) {
            clearInterval(this.intervalSportFixture);
            this.intervalSportFixture = null;
        }

        if (this.terminalFixtureList != null && this.terminalFixtureList.length > 0) {
            this.terminalFixtureList = null;
            this.terminalOddList = null;
            this.terminalSearchList = null;
        }

        return this.http
            .get(
                `${this.apisUrl}/SportFixture/${this.fixturetourId}/${this.fixturecatId}/${this.fixturesportId}/${this.fixturedate}/${langId}/${timeZone}`,
                { headers },
            )
            .toPromise()
            .then(r => {
                // console.log('Fixture', r);
                // lg('FIXTURE', r['data'], '#ff0000');
                //  lg('FIXTURE ODDs', r['odds'], '#ff0000');

                this.terminalFixtureList = (r['data'] as unknown) as FixtureModel[];
                this.terminalOddList = r['odds'];
                this.terminalSearchList = (r['data'] as unknown) as FixtureModel[];
                this._uiHelper.setChangeSportFixture();

                //Update Pre Fixture

                this.intervalSportFixture = setInterval(() => this.refreshPreFixture(this), 30000);
                this.refreshPreFixture(this);
                this.counterFixtureRefresher = 0;
                return r;
            })
            .catch(error => {
                return console.error(error);
            });
    }

    public refreshPreFixture(e) {
        if (e._uiHelper.liveFilteredData != undefined) {
            if (this.terminalFixtureList != null)
                this.terminalFixtureList = this.terminalFixtureList.filter(function(item) {
                    const indexOfEvent = e._uiHelper.liveFilteredData.filter(
                        ht => ht.BetradarMatchId.toString() === item.BetradarMatchId.toString(),
                    );
                    if (indexOfEvent.length > 0) {
                        return false;
                    } else {
                        let currentTime = new Date();
                        if (currentTime > new Date(item.MatchDate)) return false;
                        else return true;
                    }
                });
        } else {
            if (this.terminalFixtureList != null)
                this.terminalFixtureList = this.terminalFixtureList.filter(function(item) {
                    let currentTime = new Date();
                    if (currentTime > new Date(item.MatchDate)) return false;
                    else return true;
                });
        }

        this.counterFixtureRefresher++;
        if (this.counterFixtureRefresher == 6) {
            //this.getSportFixture('initial');
            //this.counterFixtureRefresher = 0;
            //sayfa ziplamasi yuzunden kapatildi
        }
    }

    public getSportFixture_Search() {
        const comp = this as TournamentsService;
        //console.warn('getSportFixture_Search', this.TerminalSearchValue, comp.flag_control_getsportfixturesearch);
        if (comp.flag_control_getsportfixturesearch === 1) {
            return;
        }

        comp.flag_control_getsportfixturesearch = 1;

        //this.terminalFixtureList = this.terminalSearchList.filter(
        //  f =>
        //    f.HomeTeam.toLowerCase().indexOf(this.TerminalSearchValue.toLowerCase()) != -1 ||
        //    f.AwayTeam.toLowerCase().indexOf(this.TerminalSearchValue.toLowerCase()) != -1 ||
        //    f.HomeTeam.toUpperCase().indexOf(this.TerminalSearchValue.toUpperCase()) != -1 ||
        //    f.AwayTeam.toUpperCase().indexOf(this.TerminalSearchValue.toUpperCase()) != -1,
        //);

        this.getSportFixtureSearch(this.TerminalSearchValue.toLowerCase());

        comp.flag_control_getsportfixturesearch = 0;
    }

    public getSportFixtureSearch(searchterm) {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http
            .get(`${this.apisUrl}/SportFixtureSearch/${searchterm}/${langId}/${timeZone}`, { headers })
            .toPromise()
            .then(r => {
                console.log('Fixture', r);
                lg('FIXTURE', r['data'], '#ff0000');
                lg('FIXTURE ODDs', r['odds'], '#ff0000');

                this.terminalFixtureList = (r['data'] as unknown) as FixtureModel[];
                this.terminalOddList = (r['odds'] as unknown) as FixtureModel[];
                this.terminalSearchList = (r['data'] as unknown) as FixtureModel[];
                this._uiHelper.setChangeSportFixture();

                return r;
            })
            .catch(error => {
                return console.error(error);
            });
    }

    public getSportResult() {
        const comp = this as TournamentsService;
        return this.http
            .get(this.apisUrl + '/SportResult/' + comp.fixturesportId + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as FixtureModel[]))
            .subscribe(res => {
                this.terminalSportResult = res;
            });
    }

    public getAllUpcoming() {
        const comp = this as TournamentsService;
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

        return this.http
            .get(this.apisUrl + '/SportFixtureAll/' + langId + '/' + timeZone, { headers })
            .pipe(map((response: Response) => (response as unknown) as FixtureModel[]))
            .subscribe(res => {
                this.terminalAllUpcomingList = res;
            });
    }

    public getLiveEventOdds(e, match) {
        return this.http
            .get(this.apisUrl + '/LiveEventOdds/' + match + '/' + langId + '/' + e)
            .pipe(map((response: Response) => (response as unknown) as OddTypeModel[]));
    }

    // getMatchOddsMore(matchId) {

    //    let comp = <TournamentsService>this;
    //    return this.http.get(this.apisUrl + '/MatchOdds/' + matchId + '/' + 3)
    //        .pipe(map((response: Response) => <FixtureModel[]>response).subscribe(res => { this.terminalmatchOddsList = res; });
    // }

    public getOddType(e, match) {
        return this.http
            .get(this.apisUrl + '/MatchOddsbyGroup/' + match + '/' + langId + '/' + e)
            .pipe(map((response: Response) => (response as unknown) as OddTypeModel[]));
    }

    //// TERMİNAL SPORT BETTİNG////////////////////////////////
    public getFixtureList(e) {
        const comp = this as TournamentsService;
        return this.http
            .get(
                this.apisUrl + '/Fixture/' + e.TournamentId + '/' + langId + '/' + timeZone + '/' + comp.sportDayFilter,
            )
            .pipe(
                map((response: Response) => (response as unknown) as FixtureModel[]),
                finalize(() => (e.Loading = '')),
            );
    }

    public addOdd(odd, __RequestVerificationToken, betType = '0') {}

    //TEk geçerli odd ekleme
    public addOddNew(odd, __RequestVerificationToken, betType = '0', event, isOnlyInsert = false) {
        if (this.BettingSlip_Clicked_Button_Submit_Bet) {
            return;
        }
        this.clear_Betting_Slip_RestoreCounter();
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', __RequestVerificationToken);
        urlParams.append('OddId', odd.OddId);
        urlParams.append('BetType', betType);
        urlParams.append('LangId', langId);
        urlParams.append('EventName', event.HomeTeam + ' - ' + event.AwayTeam);
        urlParams.append('MatchId', event.MatchId);
        urlParams.append('OddsType', odd.GroupName.split('|')[1]);
        urlParams.append('OddsTypeId', odd.OddTypeId);
        urlParams.append('OddValue1', odd.OddValue);
        urlParams.append('OutCome', odd.OutCome);
        urlParams.append('ShortOddType', odd.ShortOddType);
        urlParams.append('SpecialBetValue', odd.SpecialBetValue !== '' ? '(' + odd.SpecialBetValue + ')' : '');
        urlParams.append('EventDate', event.EventDate);
        urlParams.append('SportName', event.SportNameOriginal);
        urlParams.append('TimeZone', timeZone);

        const newodd = {
            AwayTeam: event.AwayTeam,
            Banko: false,
            BetType: betType,
            Enable: true,
            EventDate: event.MatchDate != undefined ? event.MatchDate : event.EventDate,
            EventName: event.HomeTeam + ' - ' + event.AwayTeam,
            HomeTeam: event.HomeTeam,
            MatchId: event.MatchId,
            OddId1: odd.OddId,
            OddValue1: odd.OddValue,
            OddsType: odd.ShortOddType,
            OddsTypeId: odd.OddTypeId,
            OutCome: odd.OutCome,
            SpecialBetValue: odd.SpecialBetValue !== '' ? '(' + odd.SpecialBetValue + ')' : '',
            SportName: event.SportNameOriginal,
            Visibility: '',
            cards: undefined,
            liveData: undefined,
            WithBr: event.WithBr,
        };

        if (this.slipCurrents.findIndex(o => o.OddId1 == odd.OddId) == -1) {
            //Eğer kupona ekleme varsa bu kontrol var
            if (this.slipCurrents.length > this.max_event_count - 1) {
                return;
            }

            if (this.slipCurrents == undefined) this.slipCurrents = [];
            this.slipCurrents.push(newodd);

            const liveFilteredData = this._liveFixtureList;

            if (liveFilteredData && liveFilteredData.length > 0 && this.slipCurrents && this.slipCurrents.length > 0) {
                this.slipCurrents = this.slipCurrents.map(item => {
                    let cMatch = liveFilteredData.filter(liveItem => liveItem.MatchId === item.MatchId);

                    // Kırmızı Kartlar için Eski Yöntem Kapatıldı ( 23.09.2021 )
                    // if (this._cardList && this._cardList.length > 0) {
                    //     const card = this._cardList.find(s => s.EventId == item.MatchId);
                    //     item['cards'] = card;
                    // }
                    item['liveData'] = cMatch[0];
                    return item;
                });
            } else {
                this.slipCurrents = this.slipCurrents.map(item => {
                    let emptyobj: any;
                    item['cards'] = emptyobj;
                    item['liveData'] = emptyobj;
                    return item;
                });
            }
            //console.log('yeni slip', this.slipCurrents, odd);

            this.oddClickReceived.emit(1);

            const slipstring = JSON.stringify(this.slipCurrents);
            localStorage.setItem('currentslip', slipstring);
            urlParams.append('currentslip', slipstring);

            const body = urlParams.toString();

            this.responseString = '';

            comp.isClicked = [];
            comp.SystemModalButtonValueArray = [];
            comp.SystemModalButtonValue = comp.translateStaticWord('System_Combinations');
            comp.getSelectedOdds();
            comp.getCurrentSlip();
            comp.checkIsSystem();

            this.CurrentSlipReceived.emit(1);
            comp.messageType = '';

            //this.http
            //  .post(this.apisUrl + 'PickOdd', body, { headers }) // ...using post request
            //  .subscribe(
            //    data => {
            //      const dataText = data.toString();

            //      if (dataText === '') {
            //        return 'error|System Error';
            //      } else {
            //        comp.isClicked = [];
            //        comp.SystemModalButtonValueArray = [];
            //        comp.SystemModalButtonValue = comp.translateStaticWord('System_Combinations');
            //        //comp.getSelectedOdds();
            //        //comp.getCurrentSlip();
            //        this.CurrentSlipReceived.emit(1);
            //        comp.messageType = '';
            //      }
            //    },
            //    error => {
            //      console.log('Error happened' + error);
            //      this.responseString = 'error|System Error';
            //    },
            //    () => { },
            //  );
        } else {
            if (isOnlyInsert === true) {
                return;
            }
            const ixofevent = this.slipCurrents.findIndex(o => o.OddId1 == odd.OddId);
            this.slipCurrents.splice(ixofevent, 1);
            const slipstring = JSON.stringify(this.slipCurrents);
            localStorage.setItem('currentslip', slipstring);
            this.slipCurrents = JSON.parse(localStorage.getItem('currentslip'));

            this.oddClickReceived.emit(1);
            this.responseString = '';
            comp.getSelectedOdds();
            comp.getCurrentSlip();
            comp.checkIsSystem();
            this.CurrentSlipReceived.emit(1);
            //this.http
            //  .post(this.apisUrl + 'PickOdd', body, { headers }) // ...using post request
            //  .subscribe(
            //    data => {
            //      const dataText = data.toString();

            //      if (dataText === '') {
            //        return 'error|System Error';
            //      } else {
            //        comp.isClicked = [];
            //        comp.SystemModalButtonValueArray = [];
            //        comp.SystemModalButtonValue = comp.translateStaticWord('System_Combinations');
            //        comp.getSelectedOdds();
            //        comp.getCurrentSlip();
            //        comp.messageType = '';
            //        this.CurrentSlipReceived.emit(1);
            //      }
            //    },
            //    error => {
            //      console.log('Error happened' + error);
            //      this.responseString = 'error|System Error';
            //    },
            //    () => { },
            //  );
        }

        if (isOnlyInsert === true) {
            setInterval(() => {
                this.changeSlipAmount(this.amount, this.BettingSlip_Menu_SlipType);
            }, 500);
        }

        this.refreshBrWidgetMarkets();
    }
    public addOddOutRights(odd, __RequestVerificationToken, betType = '2', event, isOnlyInsert = false) {
        if (this.BettingSlip_Clicked_Button_Submit_Bet) {
            return;
        }

        this.clear_Betting_Slip_RestoreCounter();
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', __RequestVerificationToken);
        urlParams.append('OddId', odd.OddId);
        urlParams.append('BetType', betType);
        urlParams.append('LangId', langId);
        urlParams.append('EventName', event.HomeTeam + ' - ' + event.AwayTeam);
        urlParams.append('MatchId', event.MatchId);
        urlParams.append('OddsType', event.EventName.split('|')[1]);
        urlParams.append('OddsTypeId', odd.OddTypeId);
        urlParams.append('OddValue1', odd.OddValue);
        urlParams.append('OutCome', odd.OutCome);
        urlParams.append('ShortOddType', odd.ShortOddType);
        urlParams.append('SpecialBetValue', odd.SpecialBetValue !== '' ? '(' + odd.SpecialBetValue + ')' : '');
        urlParams.append('EventDate', event.EventDate);
        urlParams.append('SportName', event.SportNameOriginal);
        urlParams.append('TimeZone', timeZone);

        const newodd = {
            AwayTeam: event.AwayTeam,
            Banko: false,
            BetType: betType,
            Enable: true,
            EventDate: event.MatchDate != undefined ? event.MatchDate : event.EventDate,
            EventName: event.HomeTeam + ' - ' + odd.OutCome,
            HomeTeam: event.HomeTeam,
            MatchId: event.MatchId,
            OddId1: odd.OddId,
            OddValue1: odd.OddValue,
            OddsType: event.EventName,
            OddsTypeId: odd.OddTypeId,
            OutCome: odd.OutCome,
            SpecialBetValue: '',
            SportName: event.SportNameOriginal,
            Visibility: '',
            cards: undefined,
            liveData: undefined,
            WithBr: event.WithBr,
        };

        if (this.slipCurrents.findIndex(o => o.OddId1 == odd.OddId) == -1) {
            //Eğer kupona ekleme varsa bu kontrol var
            if (this.slipCurrents.length > this.max_event_count - 1) {
                return;
            }

            if (this.slipCurrents == undefined) this.slipCurrents = [];
            this.slipCurrents.push(newodd);

            const liveFilteredData = this._liveFixtureList;

            if (liveFilteredData && liveFilteredData.length > 0 && this.slipCurrents && this.slipCurrents.length > 0) {
                this.slipCurrents = this.slipCurrents.map(item => {
                    let cMatch = liveFilteredData.filter(liveItem => liveItem.MatchId === item.MatchId);

                    // Kırmızı Kartlar için Eski Yöntem Kapatıldı ( 23.09.2021 )
                    // if (this._cardList && this._cardList.length > 0) {
                    //     const card = this._cardList.find(s => s.EventId == item.MatchId);
                    //     item['cards'] = card;
                    // }
                    item['liveData'] = cMatch[0];
                    return item;
                });
            } else {
                this.slipCurrents = this.slipCurrents.map(item => {
                    let emptyobj: any;
                    item['cards'] = emptyobj;
                    item['liveData'] = emptyobj;
                    return item;
                });
            }
            //console.log('yeni slip', this.slipCurrents, odd);

            this.oddClickReceived.emit(1);

            const slipstring = JSON.stringify(this.slipCurrents);
            localStorage.setItem('currentslip', slipstring);
            urlParams.append('currentslip', slipstring);

            const body = urlParams.toString();

            this.responseString = '';

            comp.isClicked = [];
            comp.SystemModalButtonValueArray = [];
            comp.SystemModalButtonValue = comp.translateStaticWord('System_Combinations');
            comp.getSelectedOdds();
            comp.getCurrentSlip();
            comp.checkIsSystem();

            this.CurrentSlipReceived.emit(1);
            comp.messageType = '';

            //this.http
            //  .post(this.apisUrl + 'PickOdd', body, { headers }) // ...using post request
            //  .subscribe(
            //    data => {
            //      const dataText = data.toString();

            //      if (dataText === '') {
            //        return 'error|System Error';
            //      } else {
            //        comp.isClicked = [];
            //        comp.SystemModalButtonValueArray = [];
            //        comp.SystemModalButtonValue = comp.translateStaticWord('System_Combinations');
            //        //comp.getSelectedOdds();
            //        //comp.getCurrentSlip();
            //        this.CurrentSlipReceived.emit(1);
            //        comp.messageType = '';
            //      }
            //    },
            //    error => {
            //      console.log('Error happened' + error);
            //      this.responseString = 'error|System Error';
            //    },
            //    () => { },
            //  );
        } else {
            if (isOnlyInsert === true) {
                return;
            }
            const ixofevent = this.slipCurrents.findIndex(o => o.OddId1 == odd.OddId);
            this.slipCurrents.splice(ixofevent, 1);
            const slipstring = JSON.stringify(this.slipCurrents);
            localStorage.setItem('currentslip', slipstring);
            this.slipCurrents = JSON.parse(localStorage.getItem('currentslip'));

            this.oddClickReceived.emit(1);
            this.responseString = '';
            comp.getSelectedOdds();
            comp.getCurrentSlip();
            comp.checkIsSystem();
            this.CurrentSlipReceived.emit(1);
            //this.http
            //  .post(this.apisUrl + 'PickOdd', body, { headers }) // ...using post request
            //  .subscribe(
            //    data => {
            //      const dataText = data.toString();

            //      if (dataText === '') {
            //        return 'error|System Error';
            //      } else {
            //        comp.isClicked = [];
            //        comp.SystemModalButtonValueArray = [];
            //        comp.SystemModalButtonValue = comp.translateStaticWord('System_Combinations');
            //        comp.getSelectedOdds();
            //        comp.getCurrentSlip();
            //        comp.messageType = '';
            //        this.CurrentSlipReceived.emit(1);
            //      }
            //    },
            //    error => {
            //      console.log('Error happened' + error);
            //      this.responseString = 'error|System Error';
            //    },
            //    () => { },
            //  );
        }
        comp.changeSlipAmount(comp.amount, 1);
        if (isOnlyInsert === true) {
            setInterval(() => {
                this.changeSlipAmount(this.amount, this.BettingSlip_Menu_SlipType);
            }, 500);
        }

        this.refreshBrWidgetMarkets();
    }

    public refreshBrWidgetMarkets() {
        if (typeof betaluxBr !== 'undefined' && betaluxBr.get('betrecommend').setMarkets) {
            const slipOddsIds = this.slipCurrents.map(item => {
                return item.OddId1;
            });

            betaluxBr.get('betrecommend').setMarkets(slipOddsIds);
        }
    }

    private checkIsSystem() {
        if (this.slipCurrents && this.slipCurrents.length > 0) {
            this.isMultiWay = new Set(this.slipCurrents.map(i => i.MatchId)).size !== this.slipCurrents.length;
        }
    }

    public addLiveOdd(oddId, __RequestVerificationToken) {
        if (this.BettingSlip_Clicked_Button_Submit_Bet) {
            return;
        }
        this.clear_Betting_Slip_RestoreCounter();
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', __RequestVerificationToken);
        urlParams.append('OddId', oddId);
        urlParams.append('BetType', '1');
        urlParams.append('LangId', langId);
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'PickOdd', body, { headers }) // ...using post request
            .subscribe(
                data => {
                    const dataText = data.toString();

                    if (dataText === '') {
                        return 'error|System Error';
                    } else {
                        comp.isClicked = [];
                        comp.SystemModalButtonValueArray = [];
                        comp.SystemModalButtonValue = comp.translateStaticWord('System_Combinations');
                        comp.getSelectedOdds();
                        comp.getCurrentSlip();
                        comp.checkIsSystem();
                        comp.messageType = '';
                    }
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                () => {},
            );
    }

    public addOutRightOdd(oddId, __RequestVerificationToken) {
        if (this.BettingSlip_Clicked_Button_Submit_Bet) {
            return;
        }

        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', __RequestVerificationToken);
        urlParams.append('OddId', oddId);
        urlParams.append('BetType', '2');
        urlParams.append('LangId', langId);
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'PickOdd', body, { headers }) // ...using post request
            .subscribe(
                data => {
                    const dataText = data.toString();

                    if (dataText === '') {
                        return 'error|System Error';
                    } else {
                        comp.getSelectedOdds();
                        comp.getCurrentSlip();
                        comp.messageType = '';
                    }
                },
                error => {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                () => {},
            );
    }

    public getSelectedOdds() {
        return;
        this.http
            .get(this.apisUrl + '/SelectedOdds')
            .pipe(map((response: Response) => (response as unknown) as OddModel[]))
            .subscribe(
                res => {
                    this.selectedOdds = res;
                    SetLanguage('', '');
                },
                err => console.log(err),
            );
    }

    public getSystemSlips() {
        // if (this.slipCurrents.length>0)
        // this.systemSlips = this.slipCurrents.filter(s =>
        //    s.Enable == true&& s.Banko ==false
        //    );
        const urlParams = new URLSearchParams();
        const slipstring = JSON.stringify(this.slipCurrents);
        urlParams.append('currentslip', slipstring);

        const body = urlParams.toString();
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

        this.http.post(this.apisUrl + '/SystemItems', body, { headers }).subscribe(
            (res: SlipModel[]) => {
                this.systemSlips = res;
            },
            err => console.log(err),
        );
    }

    public getCurrentSlip() {
        return;
        const comp = this as TournamentsService;

        if (comp.flag_control_getcurrentslip == 1) {
            return;
        }

        comp.flag_control_getcurrentslip = 1;

        const urlParams = new URLSearchParams();
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

        const slipstring = localStorage.getItem('currentslip');
        urlParams.append('currentslip', slipstring);

        const body = urlParams.toString();

        this.responseString = '';

        this.http
            .post(this.apisUrl + '/CurrentSlip', body, { headers })
            .pipe()
            .subscribe(
                (res: any[]) => {
                    const liveFilteredData = this._liveFixtureList;

                    if (liveFilteredData && liveFilteredData.length > 0 && res && res.length > 0) {
                        res = res.map(item => {
                            let cMatch = liveFilteredData.filter(liveItem => liveItem.MatchId === item.MatchId);

                            // Kırmızı Kartlar için Eski Yöntem Kapatıldı ( 23.09.2021 )
                            // if (this._cardList && this._cardList.length > 0) {
                            //     const card = this._cardList.find(s => s.EventId == item.MatchId);
                            //     item['cards'] = card;
                            // }
                            item['liveData'] = cMatch[0];
                            return item;
                        });
                    }
                    this.slipCurrents = res;

                    //console.log(res);
                    this.changeSlipAmount(-1, -1);
                    this.CurrentSlipReceived.emit(1);
                    if (res.length < 2) {
                        SetLanguage('', '');
                    }
                    comp.flag_control_getcurrentslip = 0;
                },
                err => {
                    console.log(err);
                    comp.flag_control_getcurrentslip = 0;
                },
            );
    }

    public refreshCurrentSlip() {
        return;
        const comp = this as TournamentsService;

        if (comp.flag_control_refreshcurrentslip === 1) {
            return;
        }

        comp.flag_control_refreshcurrentslip = 1;

        const urlParams = new URLSearchParams();
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

        const slipstring = localStorage.getItem('currentslip');
        urlParams.append('currentslip', slipstring);

        const body = urlParams.toString();

        this.responseString = '';

        this.http
            .post(this.apisUrl + '/RefreshCurrentSlip/' + langId, body, { headers })
            .pipe()
            .subscribe(
                (data: any) => {
                    this.slipCurrents.map(item => {
                        const oddd = data.filter(f => f.OddId1 == item.OddId1);
                        if (oddd != undefined && oddd.length > 0) {
                            const _odd = oddd[0];
                            item.OddValue1 = _odd.OddValue1;
                            item.SpecialBetValue = _odd.SpecialBetValue;
                            item.Visibility = _odd.Visibility;
                            item.ShortOddType = _odd.ShortOddType;
                        }
                    });
                    const slipstring = JSON.stringify(this.slipCurrents);
                    localStorage.setItem('currentslip', slipstring);

                    comp.getCurrentSlip();
                    comp.flag_control_refreshcurrentslip = 0;
                },
                error => {
                    console.log('Error happened' + error);
                    comp.flag_control_refreshcurrentslip = 0;
                },
                () => {},
            );
    }

    public removeOdd(oddId) {
        if (this.BettingSlip_Clicked_Button_Submit_Bet) {
            return;
        }

        const comp = this as TournamentsService;

        const ixofevent = this.slipCurrents.findIndex(o => o.OddId1 == oddId);
        this.slipCurrents.splice(ixofevent, 1);
        const slipstring = JSON.stringify(this.slipCurrents);
        localStorage.setItem('currentslip', slipstring);
        this.slipCurrents = JSON.parse(localStorage.getItem('currentslip'));
        comp.checkIsSystem();
        comp.getSelectedOdds();
        comp.getCurrentSlip();
        comp.isClicked = [];
        comp.SystemModalButtonValueArray = [];
        comp.SystemModalButtonValue = comp.translateStaticWord('System_Combinations');

        // comp.slipCurrentDimmer = "active";
        //this.http.get(this.apisUrl + '/RemoveOdd/' + oddId).subscribe(
        //  data => {
        //    const dataText = data.toString();

        //    if (dataText === '') {
        //      SetLanguage('', '');
        //      return 'error|System Error';
        //    } else {
        //      comp.getSelectedOdds();
        //      comp.getCurrentSlip();
        //      comp.isClicked = [];
        //      comp.SystemModalButtonValueArray = [];
        //      comp.SystemModalButtonValue = comp.translateStaticWord('System_Combinations');
        //    }
        //    SetLanguage('', '');
        //  },
        //  function (error) {
        //    console.log('Error happened' + error);
        //    this.responseString = 'error|System Error';
        //  },
        //  () => { },
        //);
        this.refreshBrWidgetMarkets();
    }

    public clearSlip() {
        if (this.BettingSlip_Clicked_Button_Submit_Bet) {
            return;
        }

        const comp = this as TournamentsService;

        this.slipCurrents = [];
        const slipstring = JSON.stringify(this.slipCurrents);
        localStorage.setItem('currentslip', slipstring);

        comp.getSelectedOdds();
        comp.getCurrentSlip();
        comp.messageType = '';
        comp.BettingSlip_Menu_SlipType = 1;
        comp.CalculatorValue = 5;
        comp.changeSlipAmount(
            ((Number(comp.CalculatorValue) * 100) / (100 + comp.tax)).toFixed(4),
            comp.BettingSlip_Menu_SlipType,
        );
        SetLanguage('', '');

        //// comp.slipCurrentDimmer = "active";
        //this.http.get(this.apisUrl + '/ClearSlip', RESPONSE_AS_TEXT_X_WWW).subscribe(
        //  data => {
        //    //console.log(data);
        //    const dataText = data['body'].toString();

        //    if (dataText === '') {
        //      SetLanguage('', '');
        //      return 'error|System Error';
        //    } else {
        //      comp.getSelectedOdds();
        //      comp.getCurrentSlip();
        //      comp.messageType = '';
        //      comp.BettingSlip_Menu_SlipType = 1;
        //      comp.CalculatorValue = 5;
        //      comp.changeSlipAmount(
        //        ((Number(comp.CalculatorValue) * 100) / (100 + comp.tax)).toFixed(4),
        //        comp.BettingSlip_Menu_SlipType,
        //      );
        //    }
        //    SetLanguage('', '');
        //  },
        //  error => {
        //    console.log(error);
        //    this.responseString = 'error|System Error';
        //  },
        //  () => { },
        //);
        this.refreshBrWidgetMarkets();
    }

    public changeSlipAmount(amount, slipType) {
        if (amount != -1) {
            this.amount = amount;
        }
        if (slipType != -1) {
            this.slipType = slipType + '';
        }
        const comp = this as TournamentsService;
        const bodyString = JSON.stringify(''); // Stringify payload

        if (comp.flag_control_changeslipamount == 1) {
            return;
        }
        if (this.slipCurrents && this.slipCurrents.length === 1) {
            this.BettingSlip_Menu_SlipType = 0;
        }
        comp.flag_control_changeslipamount = 1;

        // Deluxia daki Yapı (System için Input Kullanıldı)
        // let values = $('input[name="systemslipitem"]').map(function () {
        //    return this.value
        // }).get();

        // Terminal deki Yapı (System için Button Kullanıldı)
        const values = $('button[name="systemslipitem"]')
            .map(function() {
                return this.value;
            })
            .get();

        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', $('input[name="__RequestVerificationToken"]').val());
        urlParams.append('stake', this.amount);
        urlParams.append('sliptype', this.slipType);
        urlParams.append('values', values);

        const slipstring = JSON.stringify(this.slipCurrents);
        urlParams.append('currentslip', slipstring);

        const body = urlParams.toString();
        this.responseString = '';
        this.http
            .post(this.apisUrl + 'CurrentSlipAmount', body, { headers }) // ...using post request
            .subscribe(
                data => {
                    const dataText = data.toString();

                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        const jsonData = data as SlipAmount[];
                        comp.slipAmount = jsonData[0];
                        if (typeof betaluxBr !== 'undefined' && betaluxBr.get('betrecommend').setMaxGain) {
                            // remove ',' from max gain
                            betaluxBr
                                .get('betrecommend')
                                .setMaxGain([comp.slipAmount.MaxGain.toString().replace(',', '')]);
                        }
                    }
                    comp.flag_control_changeslipamount = 0;
                },
                error => {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                    comp.flag_control_changeslipamount = 0;
                },
                () => {},
            );
    }

    public submitBet(amount) {
        const comp = this as TournamentsService;
        comp.slipCurrentDimmer = 'active';
        console.log(this.slipType);
        if (amount < 1 && this.slipType != '2') {
            comp.slipCurrentDimmer = '';
            SetLanguage('', '');
            this.messageType = 'amountMessage';
        } else if (comp.coreService.isLogged != true) {
            comp.slipCurrentDimmer = '';
            SetLanguage('', '');
            this.messageType = 'loginMessage';
        } else {
            const options = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/x-www-form-urlencoded',
                }),
                observe: 'response' as 'body',
                responseType: 'text' as 'text',
            };

            // Deluxia daki Yapı (System için Input Kullanıldı)
            // let values = $('input[name="systemslipitem"]').map(function () {
            //    return this.value
            // }).get();

            // Terminal deki Yapı (System için Button Kullanıldı)
            const values = $('button[name="systemslipitem"]')
                .map(function() {
                    return this.value;
                })
                .get();

            const urlParams = new URLSearchParams();
            urlParams.append('__RequestVerificationToken', $('input[name="__RequestVerificationToken"]').val());
            urlParams.append('stake', amount);
            urlParams.append('sliptype', this.slipType);
            urlParams.append('langid', langId);
            urlParams.append('langcode', langCode);
            urlParams.append('values', values);

            const slipstring = JSON.stringify(this.slipCurrents);
            urlParams.append('currentslip', slipstring);

            const body = urlParams.toString();
            this.responseString = '';
            this.http
                .post(this.apisUrl + 'PlaceBet', body, options) // ...using post request
                .subscribe(
                    data => {
                        comp._uiHelper.AllscreenButtonActive(true);
                        const dataText = data['body'];
                        console.log(dataText);

                        try {
                            if (typeof betaluxBr !== 'undefined' && betaluxBr.isActive('betrecommend')) {
                                const isWithBr = this.slipCurrents.some(slip => slip.WithBr === true);
                                const onlyBrTotalOddValue = this.slipCurrents
                                    .filter(slip => slip.WithBr === true)
                                    .reduce((acc, slip) => acc * slip.OddValue1, 1);
                                const marketIds = this.slipCurrents.map(slip => slip.OddId1);
                                betaluxBr.get('betrecommend').sendSlip({
                                    isSuccess: dataText.split('|')[0] == 'success' ? true : false,
                                    marketIds: marketIds,
                                    withBr: isWithBr ? 'true' : 'false',
                                    reason: dataText.split('|')[1],
                                    slipId: dataText.split('|')[2],
                                    oddIncreasePercentage: onlyBrTotalOddValue,
                                });
                            }
                        } catch (e) {
                            console.warn(e);
                        }

                        if (dataText == '') {
                            return 'error|System Error';
                        } else {
                            if (dataText.split('|')[0] == 'error') {
                                comp.messageType = 'errorMessage';
                                comp.message = dataText.split('|')[1];
                            } else if (dataText.split('|')[0] == 'errorcode') {
                                comp.messageType = 'errorMessage';
                                comp.message = TranslateOnlyText(dataText.split('|')[1]);
                            } else if (dataText.split('|')[0] == 'success') {
                                if (comp.slipType != '2') {
                                    if (dataText.includes(',')) {
                                        const newResult = dataText.split(',');
                                        comp.getPrintSlip(newResult[0].split('|')[2]);
                                    } else {
                                        comp.getPrintSlip(dataText.split('|')[2]);
                                    }
                                } else {
                                    if (dataText.includes(',')) {
                                        const newResult = dataText.split(',');
                                        comp.getPrintSlip(newResult[0].split('|')[2]);
                                    } else {
                                        const newResult = dataText.split(' ');
                                        comp.getPrintSlip(newResult[0].split('|')[2]);
                                    }
                                }
                                // comp.printSlip_SlipId = dataText.split('|')[2];
                                comp.rbscounterValue = 11;
                                comp.rbscounterValueGreen = 11;
                                comp.getSelectedOdds();
                                comp.getCurrentSlip();
                                comp.messageType = 'successMessage';
                                comp.clearSlip();
                                setTimeout(function() {
                                    comp.messageType = '';
                                }, 5000);
                                comp.coreService.configureClient();
                                comp.BettingSlip_Menu_SlipType = 1;
                                comp.CalculatorValue = 5;
                                comp.changeSlipAmount(
                                    ((Number(comp.CalculatorValue) * 100) / (100 + comp.tax)).toFixed(4),
                                    comp.BettingSlip_Menu_SlipType,
                                );
                                comp.isClicked = [];
                                comp.SystemModalButtonValueArray = [];
                                comp.SystemModalButtonValue = comp.translateStaticWord('System_Combinations');
                                //console.log('SLIP___ID__:', comp.printSlip_SlipId);
                                comp.rsbCounterVisible = 1;
                                setTimeout(function() {
                                    comp.RsbCounter();
                                }, 5000);

                                //
                                // Print Slip Test : 29155
                                // comp.getPrintSlip(comp.printSlip_SlipId);
                                // comp.getBettingSlip_SlipDetail(comp.printSlip_SlipId);
                            } else {
                                comp.messageType = 'errorMessage';
                                comp.message = dataText;
                            }
                            comp.getCurrentSlip();
                        }
                        comp.slipCurrentDimmer = '';
                        comp.refreshBrWidgetMarkets();
                    },
                    function(error) {
                        comp._uiHelper.AllscreenButtonActive(true);
                        console.log('Error happened' + error);
                        this.responseString = 'error|System Error';
                    },
                    function() {},
                );
        }
    }

    public submitBetTemp(amount) {
        const comp = this as TournamentsService;
        comp.slipCurrentDimmer = 'active';
        console.log(this.slipType);
        if (amount < 1 && this.slipType != '2') {
            comp.slipCurrentDimmer = '';
            SetLanguage('', '');
            this.messageType = 'amountMessage';
        } else if (comp.coreService.isLogged != true) {
            comp.slipCurrentDimmer = '';
            SetLanguage('', '');
            this.messageType = 'loginMessage';
        } else {
            const options = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/x-www-form-urlencoded',
                }),
                observe: 'response' as 'body',
                responseType: 'text' as 'text',
            };

            // Deluxia daki Yapı (System için Input Kullanıldı)
            // let values = $('input[name="systemslipitem"]').map(function () {
            //    return this.value
            // }).get();

            // Terminal deki Yapı (System için Button Kullanıldı)
            const values = $('button[name="systemslipitem"]')
                .map(function() {
                    return this.value;
                })
                .get();

            const urlParams = new URLSearchParams();
            urlParams.append('__RequestVerificationToken', $('input[name="__RequestVerificationToken"]').val());
            urlParams.append('stake', amount);
            urlParams.append('sliptype', this.slipType);
            urlParams.append('langid', langId);
            urlParams.append('langcode', langCode);
            urlParams.append('values', values);

            const slipstring = JSON.stringify(this.slipCurrents);
            urlParams.append('currentslip', slipstring);

            const body = urlParams.toString();
            this.responseString = '';
            this.http
                .post(this.apisUrl + 'PlaceBetTemp', body, options) // ...using post request
                .subscribe(
                    function(data) {
                        const dataText = data['body'];
                        console.log('datax', dataText);
                        comp._uiHelper.AllscreenButtonActive(true);
                        if (dataText == '') {
                            return 'error|System Error';
                        } else {
                            if (dataText.split('|')[0] == 'error') {
                                comp.messageType = 'errorMessage';
                                comp.message = dataText.split('|')[1];
                            } else if (dataText.split('|')[0] == 'errorcode') {
                                comp.messageType = 'errorMessage';
                                comp.message = TranslateOnlyText(dataText.split('|')[1]);
                            } else if (dataText.split('|')[0] == 'success') {
                                if (comp.slipType != '2') {
                                    if (dataText.includes(',')) {
                                        const newResult = dataText.split(',');
                                        comp.getPrintSlipTemp(newResult[0].split('|')[2]);
                                    } else {
                                        comp.getPrintSlipTemp(dataText.split('|')[2]);
                                    }
                                } else {
                                    if (dataText.includes(',')) {
                                        const newResult = dataText.split(',');
                                        comp.getPrintSlipTemp(newResult[0].split('|')[2]);
                                    } else {
                                        const newResult = dataText.split(' ');
                                        comp.getPrintSlipTemp(newResult[0].split('|')[2]);
                                    }
                                }
                                // comp.printSlip_SlipId = dataText.split('|')[2];
                                comp.rbscounterValue = 11;
                                comp.rbscounterValueGreen = 11;
                                comp.getSelectedOdds();
                                comp.getCurrentSlip();
                                comp.messageType = 'successMessage';
                                comp.clearSlip();

                                setTimeout(function() {
                                    comp.messageType = '';
                                }, 5000);
                                comp.coreService.configureClient();
                                comp.BettingSlip_Menu_SlipType = 1;
                                comp.CalculatorValue = 5;
                                comp.changeSlipAmount(
                                    ((Number(comp.CalculatorValue) * 100) / (100 + comp.tax)).toFixed(4),
                                    comp.BettingSlip_Menu_SlipType,
                                );
                                comp.isClicked = [];
                                comp.SystemModalButtonValueArray = [];
                                comp.SystemModalButtonValue = comp.translateStaticWord('System_Combinations');
                                console.log('SLIP___ID__:', comp.printSlip_SlipId);
                                comp.rsbCounterVisible = 1;
                                setTimeout(function() {
                                    comp.RsbCounter();
                                }, 5000);

                                //
                                // Print Slip Test : 29155
                                // comp.getPrintSlip(comp.printSlip_SlipId);
                                // comp.getBettingSlip_SlipDetail(comp.printSlip_SlipId);
                            } else {
                                comp.messageType = 'errorMessage';
                                comp.message = dataText;
                            }
                            comp.getCurrentSlip();
                        }
                        comp.slipCurrentDimmer = '';
                    },
                    function(error) {
                        comp._uiHelper.AllscreenButtonActive(true);
                        console.log('Error happened' + error);
                        this.responseString = 'error|System Error';
                    },
                    function() {},
                );
        }
    }

    public RsbCounter() {
        // setTimeout(() => this.doSetTimeout(), 1000);
        this.rbsSetIntervalClear = setInterval(() => this.doSetTimeout(), 1000);
    }

    public doSetTimeout() {
        this.rbscounterValue = this.rbscounterValue - 1;
        if (this.rbscounterValue == 10) {
            const rbsbutton = 'rbscounter10';
            if (document.getElementById(rbsbutton) != null) {
                document.getElementById(rbsbutton).style.backgroundColor = 'lightgray';
            }
        }
        if (this.rbscounterValue == 9) {
            const rbsbutton = 'rbscounter9';
            if (document.getElementById(rbsbutton) != null) {
                document.getElementById(rbsbutton).style.backgroundColor = 'lightgray';
            }
        }
        if (this.rbscounterValue == 8) {
            const rbsbutton = 'rbscounter8';
            if (document.getElementById(rbsbutton) != null) {
                document.getElementById(rbsbutton).style.backgroundColor = 'lightgray';
            }
        }
        if (this.rbscounterValue == 7) {
            const rbsbutton = 'rbscounter7';
            if (document.getElementById(rbsbutton) != null) {
                document.getElementById(rbsbutton).style.backgroundColor = 'lightgray';
            }
        }
        if (this.rbscounterValue == 6) {
            const rbsbutton = 'rbscounter6';
            if (document.getElementById(rbsbutton) != null) {
                document.getElementById(rbsbutton).style.backgroundColor = 'lightgray';
            }
        }
        if (this.rbscounterValue == 5) {
            const rbsbutton = 'rbscounter5';
            if (document.getElementById(rbsbutton) != null) {
                document.getElementById(rbsbutton).style.backgroundColor = 'lightgray';
            }
        }
        if (this.rbscounterValue == 4) {
            const rbsbutton = 'rbscounter4';
            if (document.getElementById(rbsbutton) != null) {
                document.getElementById(rbsbutton).style.backgroundColor = 'lightgray';
            }
        }
        if (this.rbscounterValue == 3) {
            const rbsbutton = 'rbscounter3';
            if (document.getElementById(rbsbutton) != null) {
                document.getElementById(rbsbutton).style.backgroundColor = 'lightgray';
            }
        }
        if (this.rbscounterValue == 2) {
            const rbsbutton = 'rbscounter2';
            if (document.getElementById(rbsbutton) != null) {
                document.getElementById(rbsbutton).style.backgroundColor = 'lightgray';
            }
        }
        if (this.rbscounterValue == 1) {
            const rbsbutton = 'rbscounter1';
            if (document.getElementById(rbsbutton) != null) {
                document.getElementById(rbsbutton).style.backgroundColor = 'lightgray';
            }
            clearInterval(this.rbsSetIntervalClear);
            this.rsbCounterVisible = 0;
            this.rbscounterValue = 11;
            // setTimeout(() => this.doSetTimeoutGreen(), 100);
            // this.rbsSetIntervalClearGreen = setInterval(() => this.doSetTimeoutGreen(), 100);
        }
    }

    public doSetTimeoutGreen() {
        this.rbscounterValueGreen = this.rbscounterValueGreen - 1;
        if (this.rbscounterValueGreen == 10) {
            const rbsbutton = 'rbscounter' + 10;
            document.getElementById(rbsbutton).style.backgroundColor = 'orange';
        }
        if (this.rbscounterValueGreen == 9) {
            const rbsbutton = 'rbscounter' + 9;
            document.getElementById(rbsbutton).style.backgroundColor = 'orange';
        }
        if (this.rbscounterValueGreen == 8) {
            const rbsbutton = 'rbscounter' + 8;
            document.getElementById(rbsbutton).style.backgroundColor = 'orange';
        }
        if (this.rbscounterValueGreen == 7) {
            const rbsbutton = 'rbscounter' + 7;
            document.getElementById(rbsbutton).style.backgroundColor = 'orange';
        }
        if (this.rbscounterValueGreen == 6) {
            const rbsbutton = 'rbscounter' + 6;
            document.getElementById(rbsbutton).style.backgroundColor = 'orange';
        }
        if (this.rbscounterValueGreen == 5) {
            const rbsbutton = 'rbscounter' + 5;
            document.getElementById(rbsbutton).style.backgroundColor = 'orange';
        }
        if (this.rbscounterValueGreen == 4) {
            const rbsbutton = 'rbscounter' + 4;
            document.getElementById(rbsbutton).style.backgroundColor = 'orange';
        }
        if (this.rbscounterValueGreen == 3) {
            const rbsbutton = 'rbscounter' + 3;
            document.getElementById(rbsbutton).style.backgroundColor = 'orange';
        }
        if (this.rbscounterValueGreen == 2) {
            const rbsbutton = 'rbscounter' + 2;
            document.getElementById(rbsbutton).style.backgroundColor = 'orange';
        }
        if (this.rbscounterValueGreen == 1) {
            const rbsbutton = 'rbscounter' + 1;
            document.getElementById(rbsbutton).style.backgroundColor = 'orange';
            clearInterval(this.rbsSetIntervalClearGreen);
        }
    }

    public controlBet(amount) {
        const comp = this as TournamentsService;

        if (amount < 1 && this.slipType != '2') {
        } else if (comp.coreService.isLogged != true) {
        } else {
            const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

            // Deluxia daki Yapı (System için Input Kullanıldı)
            // let values = $('input[name="systemslipitem"]').map(function () {
            //    return this.value
            // }).get();

            // Terminal deki Yapı (System için Button Kullanıldı)
            const values = $('button[name="systemslipitem"]')
                .map(function() {
                    return this.value;
                })
                .get();

            const urlParams = new URLSearchParams();
            urlParams.append('__RequestVerificationToken', $('input[name="__RequestVerificationToken"]').val());
            urlParams.append('stake', amount);
            urlParams.append('sliptype', this.slipType);
            urlParams.append('langid', langId);
            urlParams.append('langcode', langCode);
            urlParams.append('values', values);

            const slipstring = JSON.stringify(this.slipCurrents);
            urlParams.append('currentslip', slipstring);

            const body = urlParams.toString();
            this.responseString = '';
            this.http
                .post(this.apisUrl + 'ControlSlip', body, { headers }) // ...using post request
                .subscribe(
                    function(data) {
                        const dataText = data.toString();

                        if (dataText == '') {
                            return 'error|System Error';
                        } else {
                            if (dataText.split('|')[0] == 'error') {
                                comp.messageType = 'errorMessage';
                                comp.message = dataText.split('|')[1];
                            } else if (dataText.split('|')[0] == 'errorcode') {
                                comp.messageType = 'errorMessage';
                                comp.message = TranslateOnlyText(dataText.split('|')[1]);
                            } else if (dataText.split('|')[0] == 'success') {
                            } else {
                                comp.messageType = 'errorMessage';
                                comp.message = dataText;
                            }
                        }
                    },
                    function(error) {
                        console.log('Error happened' + error);
                        this.responseString = 'error|System Error';
                    },
                    function() {},
                );
        }
    }

    public getPopularOdds() {
        return this.http
            .get(this.apisUrl + '/PopularFixture/' + langId + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as FixtureModel[]));
    }

    public getSearch(result) {
        this.searchResponse.push(result);
    }

    public changeSubMenu(e) {
        this.subMenuType = e;
        this.isMatchDetail = false;
        if (e == 1) {
            this.highlightObservable = this.http
                .get(this.apisUrl + '/HighlightsFixture/' + langId + '/' + timeZone)
                .pipe(map((response: Response) => (response as unknown) as FixtureModel[]));
        } else if (e == 2) {
            this.lastMinuteObservable = this.http
                .get(this.apisUrl + '/LastMinuteFixture/' + langId + '/' + timeZone)
                .pipe(map((response: Response) => (response as unknown) as FixtureModel[]));

            // this.lastMinuteObservable.subscribe((s) => {
            //    console.log("SUBSCRİBELASTMİNUTE", s);
            // });
        } else if (e == 5) {
            this.todayObservable = this.http
                .get(this.apisUrl + '/TodayFixture/' + langId + '/' + timeZone)
                .pipe(map((response: Response) => (response as unknown) as FixtureModel[]));
        }
    }

    public GetFixtureSearch() {
        // this.liveFixtureListSearch = this._liveFixtureList.filter(f => f.HomeTeam.indexOf == this.TerminalSearchValue || f.AwayTeam.indexOf == this.TerminalSearchValue);
        // this.upcomingFixtureListSearch = this.terminalAllUpcomingList.filter(f => f.HomeTeam.indexOf == this.TerminalSearchValue || f.AwayTeam.indexOf == this.TerminalSearchValue)
    }

    public getOutrightSports() {
        return this.http
            .get(this.apisUrl + '/OutrightSports/' + langId)
            .pipe(map((response: Response) => (response as unknown) as SportsModel[]));
    }

    public getCategoryObservableListTerminal(sportId, hour) {
        return this.http
            .get(this.apisUrl + '/Countries/' + sportId + '/' + langId + '/' + hour)
            .pipe(map((response: Response) => (response as unknown) as TerminalCategoriesModel[]));
    }

    public getTournamentObservableListTerminal(sportId, categoryId) {
        // console.log('--getTournamentObservableListTerminal--', sportId, categoryId);
        // return this.http.get(this.apisUrl + '/TournamentList/' + sportId + '/' + langId + '/' + categoryId)

        //    .pipe(map((response: Response) => <TerminalTournamentsModel[]>response).subscribe(res => { this.topLeaguesModalList = res, console.log("TURNUVALAR", this.topLeaguesModalList)});

        // return this.http
        //   .get(this.apisUrl + '/TournamentList/' + sportId + '/' + langId + '/' + categoryId)
        //   .toPromise()
        //   .then(response => {
        //
        //     let d = map((response: Response) => (response as unknown) as TerminalTournamentsModel[])
        //     console.log(d);
        //
        //    return  d;
        //
        //   });

        return this.http
            .get(this.apisUrl + '/TournamentList/' + sportId + '/' + langId + '/' + categoryId)

            .pipe(map((response: Response) => (response as unknown) as any));
    }

    public getSportOutrightsList() {
        return this.http
            .get(this.apisUrl + 'SportOutrightsList/' + langId)

            .pipe(map((response: Response) => (response as unknown) as any));
    }
    public getTournamentOutrightsTerminalList(sportId) {
        return this.http
            .get(this.apisUrl + 'TournamentOutrightsTerminalList/' + sportId + '/' + langId)

            .pipe(map((response: Response) => (response as unknown) as any));
    }
    public getOutrightEventOddTerminalData(TournamentId) {
        return this.http
            .get(this.apisUrl + 'OutrightEventOddTerminalData/' + TournamentId + '/' + langId)

            .pipe(map((response: Response) => (response as unknown) as any));
    }
    public getCategoryObservable(sportId) {
        return this.http
            .get(this.apisUrl + '/OutrightCategories/' + sportId + '/' + langId)
            .pipe(map((response: Response) => (response as unknown) as CategoriesModel[]));
    }

    public getResultSportObservable() {
        return this.http
            .get(this.apisUrl + '/ResultSports/' + langId)
            .pipe(map((response: Response) => (response as unknown) as SportsModel[]));
    }

    public getResultCategoryObservable(sportId) {
        this.resultSportId = sportId;
        return this.http
            .get(this.apisUrl + '/ResultCategories/' + sportId + '/' + langId)
            .pipe(map((response: Response) => (response as unknown) as CategoriesModel[]));
    }

    public getTournamentObservable(sportId, categoryId) {
        this.resultSportId = sportId;
        return this.http
            .get(this.apisUrl + '/OutrightEvents/' + categoryId + '/' + sportId + '/' + langId)
            .pipe(map((response: Response) => (response as unknown) as TournamentsModel[]));
    }

    public getMatchObservable(matchId) {
        return this.http
            .get(this.apisUrl + '/OutrightMatchOdds/' + matchId + '/' + langId)
            .pipe(map((response: Response) => (response as unknown) as OddTypeModel[]));
    }

    public getResults(e, categoryId) {
        return this.http
            .get(
                this.apisUrl +
                    '/Results/' +
                    this.resultSportId +
                    '/' +
                    categoryId +
                    '/' +
                    e.TournamentId +
                    '/' +
                    e.TournamentName +
                    '/1/' +
                    langId +
                    '/' +
                    timeZone,
            )
            .pipe(map((response: Response) => (response as unknown) as ResultModel[]));
    }

    public getResultTerminal() {
        return this.http
            .get(this.apisUrl + '/TerminalResults/' + this.fixturesportId + '/' + langId + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as ResultModel[]))
            .subscribe(res => {
                this.terminalResultList = res;
            });
    }

    public getLiveBettingFixture() {
        return this.http
            .get(this.apisUrl + '/LiveBettingFixture/' + langId + '/0')
            .pipe(map((response: Response) => (response as unknown) as LiveFixture[]));
    }

    public getLiveBettingFixture1stHalf() {
        return this.http
            .get(this.apisUrl + '/LiveBettingFixture1stHalf/' + langId + '/0')
            .pipe(map((response: Response) => (response as unknown) as LiveFixture[]));
    }

    // Eski Yöntem Kapatıldı ( 23.09.2021 )
    // public getLiveCards() {
    //     return this.http
    //         .get(this.apisUrl + '/LiveCards/' + langId + '/0')
    //         .pipe(map((response: Response) => (response as unknown) as LiveCardModel[]));
    // }

    public getOpenBets() {
        // return this.http.get(this.apisUrl + '/OpenBetShow/')
        //    .pipe(map((response: Response) => <OpenSlipModel[]><unknown>response));
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

   
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', $('input[name="__RequestVerificationToken"]').val());
        urlParams.append('cid', this.coreService.customerUser.CustomerId);

        urlParams.append('langid', langId);
        urlParams.append('IsJacktime', this._uiHelper.terminalConfig.IsJacktimeActive.toString());

        const body = urlParams.toString();


        if (this.coreService.customerUser != undefined && this.coreService.customerUser.CustomerId != undefined)
            this.http
                .post(
                    this.apisUrl +
                        '/OpenBetShow2',body, { headers } )
                .pipe(map((response: Response) => (response as unknown) as any[]))
                .subscribe(res => {
                    if (this._uiHelper.terminalConfig.IsJacktimeActive === true) {
                        this.openSlipList = res.map(x => {
                            return {
                                ...x,
                                CashOutActive: x.CashoutValueJacktime > 0 ? ' ' : '',
                            };
                        });
                    } else {
                        this.openSlipList = res;
                    }
                });
    }
    public getOpenBets_Refresh() {
        // return this.http.get(this.apisUrl + '/OpenBetShow/')
        //    .pipe(map((response: Response) => <OpenSlipModel[]><unknown>response));
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

   
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', $('input[name="__RequestVerificationToken"]').val());
        urlParams.append('cid', this.coreService.customerUser.CustomerId);

        urlParams.append('langid', langId);
        urlParams.append('IsJacktime', this._uiHelper.terminalConfig.IsJacktimeActive.toString());

        const body = urlParams.toString();
        if (this.coreService.customerUser != undefined && this.coreService.customerUser.CustomerId != undefined)
            this.http
        .post(
            this.apisUrl +
                '/OpenBetShow2',body, { headers } )
                .pipe(map((response: Response) => (response as unknown) as any[]))
                .subscribe(res => {
                    if (this._uiHelper.terminalConfig.IsJacktimeActive === true) {
                        this.openSlipList = res.map(x => {
                            return {
                                ...x,
                                CashOutActive: x.CashoutValueJacktime > 0 ? ' ' : '',
                            };
                        });
                    } else {
                        this.openSlipList = res;
                    }
                });
        // this.getOpenBets_Refresh();
    }

    public getLiveMatchDetail(e) {
        this.isLiveMatchDetail = true;
        this.match = e;
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.get(this.apisUrl + '/LiveEvent/' + e.EventId + '/' + langId, { headers }).subscribe(
            data => {
                this.livematch = data[0];
                RenderMatch(this.livematch.BetradarMatchId);
            },
            error => console.log(error),
            () => console.log('done'),
        );
    }

    public getCashoutSlip(e) {
        this.http
            .get(this.cashoutApisUrl + '/CashOutSlips/' + langId + '/' + e + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as SlipModel[]))
            .subscribe(res => {
                this.cashOutList = res;
            });
    }

    public getCashOutSlipdetail(e) {
        this.http
            .get(this.cashoutApisUrl + '/CashoutDetail/' + langId + '/' + e + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as SlipModel[]))
            .subscribe(res => {
                this.cashOutDetailList = res;

                $('#modalopencash')
                    .modal('hide all')
                    .modal({ observeChanges: true })
                    .modal('refresh')
                    .modal('show');
            });
        this.idforcahsout = e;
    }

    public refreshCashOutSlipdetail(e) {
        this.http
            .get(this.apisUrl + '/CashoutDetail/' + langId + '/' + e + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as SlipModel[]))
            .subscribe(res => {
                this.cashOutDetailList = res;
            });
    }

    public CustomerPasswordControl(Password, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('Password', Password);

        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'CustomerPasswordControl', body, { headers }) // ...using post request
            .subscribe(
                function(data) {
                    const dataText = data.toString();

                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        if (dataText == '0') {
                            comp.customerPasswordMessageVisible = 0;
                            comp.CustomerPasswordMessage = '';
                            $('#Customer_Keyboard_Modal').modal('hide');
                            setTimeout(
                                $('#PayoutModal')
                                    .modal({
                                        detachable: false,
                                    })
                                    .modal('show'),
                                2000,
                            );
                        } else {
                            comp.customerPasswordMessageVisible = 1;
                            comp.CustomerPasswordMessage = comp.translateStaticWord('Incorrect_password');
                        }
                    }
                    comp.customerPayoutPassword = '';
                    // entry.IsLoading = false;
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );

        // this.http.get(this.apisUrl + '/CashoutDetail/' + langId + '/' + e + '/' + timeZone)
        //    .pipe(map((response: Response) => <SlipModel[]>response).subscribe(res => {
        //        this.cashOutDetailList = res;});
    }

    public getsendCashOut(CashOutValue, SlipId, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('LangId', langId);
        urlParams.append('CashOutValue', CashOutValue);
        urlParams.append('SlipId', this.idforcahsout);
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'CashOutPay', body, RESPONSE_AS_TEXT_X_WWW) // ...using post request
            .subscribe(
                data => {
                    const dataText = data['body'].toString();
                    console.log(dataText);
                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        if (dataText.split('|')[0] == 'error') {
                            comp.cashOutMessage = dataText.split('|')[1];
                            // comp.cashOutMessage = "Başarısız";
                            // comp.isWithdrawMessage = true;
                            comp.isCashOut = false;
                            console.log('error');
                        } else if (dataText.split('|')[0] == 'errorcode') {
                            // comp.isWithdrawMessage = true;
                            comp.isCashOut = false;
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.cashOutMessage = result[dataText.split('|')[1]];
                                // comp.cashOutMessage = "Başarısız";
                                console.log('errorcode');
                            });
                        } else if (dataText.split('|')[0] == 'success') {
                            // comp.isWithdrawMessage = true;
                            comp.isCashOut = true;
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.cashOutMessage = result[dataText.split('|')[1]];
                                // comp.cashOutMessage = "Başarılı";
                                console.log('success');
                                setTimeout(function() {
                                    $('#modalopencash')
                                        .modal('hide all')
                                        .modal('refresh')
                                        .modal('hide');
                                }, 2000);
                            });
                        }
                    }
                    comp.withdrawDimmer = '';
                    // entry.IsLoading = false;
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );

        // this.http.get(this.apisUrl + '/CashoutDetail/' + langId + '/' + e + '/' + timeZone)
        //    .pipe(map((response: Response) => <SlipModel[]>response).subscribe(res => {
        //        this.cashOutDetailList = res;});
    }

    public getsendCashOutOpenBets_Terminal(CashOutValue, SlipId, a) {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
            responseType: 'text' as 'text',
        };

        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('LangId', langId);
        urlParams.append('CashOutValue', CashOutValue);
        urlParams.append('SlipId', SlipId.toString());
        urlParams.append('IsJacktime', this._uiHelper.terminalConfig.IsJacktimeActive.toString());
        const body = urlParams.toString();

        console.log('trigered', CashOutValue, SlipId, a);

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'CashOutPayCustomer', body, options) // ...using post request
            .subscribe(
                data => {
                    this.getOpenBets();

                    const dataText = data.toString();
                    console.log(dataText);
                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        if (dataText.split('|')[0] == 'error') {
                            // comp.cashoutmessageTerminal = dataText.split('|')[1];
                            // setTimeout(function () { comp.cashoutMessageTerminalActive = 0; }, 3000);
                            // setTimeout(function () { comp.cashOutButtonClick = 0; }, 3000);
                            // setTimeout(function () { comp.confirmMessageActive = 0 }, 3000);

                            // setTimeout(function () { comp.cashoutmessageTerminal = "" }, 3000);
                            // comp.cashOutMessage = "Başarısız";
                            // comp.isWithdrawMessage = true;
                            comp.isCashOut = false;
                            console.log('error');
                        } else if (dataText.split('|')[0] == 'errorcode') {
                            // comp.isWithdrawMessage = true;
                            comp.isCashOut = false;
                            // $.getJSON('/lang/' + langCode + '.json', function (result) {
                            //    comp.cashoutmessageTerminal = result[dataText.split('|')[1]];
                            //    setTimeout(function () { comp.cashoutMessageTerminalActive = 0; }, 3000);
                            //    setTimeout(function () { comp.cashOutButtonClick = 0; }, 3000);
                            //    setTimeout(function () { comp.confirmMessageActive = 0 }, 3000);
                            //    //comp.confirmMessageActive = 0
                            //    setTimeout(function () { comp.cashoutmessageTerminal = "" }, 3000);

                            //    //comp.cashOutMessage = "Başarısız";
                            //    console.log("errorcode");
                            // });
                        } else if (dataText.split('|')[0] == 'success') {
                            comp.isCashOut = true;
                            // setTimeout(function () {
                            //    $('#openBetsCashoutModal')

                            //        .modal("hide")
                            // }, 1000);

                            setTimeout(function() {
                                $('#cashoutdetail_creditvoucheropenbets')
                                    .modal({
                                        detachable: false,
                                    })
                                    .modal('show');
                            }, 1000);

                            setTimeout(function() {
                                comp.coreService.configureClient();
                            }, 2000);

                            setTimeout(function() {
                                comp.location.back();
                            }, 0);
                        } else {
                            comp.isCashOut = false;
                        }
                    }
                    comp.withdrawDimmer = '';
                    // entry.IsLoading = false;
                },
                function(error) {
                    console.log('error');
                    console.log(error.toString());
                    this.responseString = 'error|System Error';
                },
                function() {},
            );

        // console.log("CashOutValue", CashOutValue);
        // console.log("SlipId", this.idforcahsout);

        // this.http.get(this.apisUrl + '/CashoutDetail/' + langId + '/' + e + '/' + timeZone)
        //    .pipe(map((response: Response) => <SlipModel[]>response).subscribe(res => {
        //        this.cashOutDetailList = res;});
    }

    public getsendCashOutCOpenBets_Terminal(CashOutValue, SlipId, a,Percent='') {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('LangId', langId);
        urlParams.append('CashOutValue', CashOutValue);
        urlParams.append('SlipId', SlipId.toString());
        urlParams.append('IsJacktime', this._uiHelper.terminalConfig.IsJacktimeActive.toString());
        urlParams.append('stakeFraction', Percent);
        const body = urlParams.toString();

        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
            responseType: 'text' as 'text',
        };

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'CashOutPayCustomer', body, options) // ...using post request
            .subscribe(
                function(data: any) {
                    const dataText = data.body;
                    console.log(data);
                    if (dataText == '') {
                        comp.coreService.CloseCashoutWaitingModal();
                        return 'error|System Error';
                    } else {
                        if (dataText.split('|')[0] == 'error') {
                            // comp.cashoutmessageTerminal = dataText.split('|')[1];
                            // setTimeout(function () { comp.cashoutMessageTerminalActive = 0; }, 3000);
                            // setTimeout(function () { comp.cashOutButtonClick = 0; }, 3000);
                            // setTimeout(function () { comp.confirmMessageActive = 0 }, 3000);

                            // setTimeout(function () { comp.cashoutmessageTerminal = "" }, 3000);
                            // comp.cashOutMessage = "Başarısız";
                            // comp.isWithdrawMessage = true;
                            comp.isCashOut = false;
                            console.log('error');
                            comp.coreService.CloseCashoutWaitingModal();
                        } else if (dataText.split('|')[0] == 'errorcode') {
                            // comp.isWithdrawMessage = true;
                            comp.isCashOut = false;
                            // $.getJSON('/lang/' + langCode + '.json', function (result) {
                            //    comp.cashoutmessageTerminal = result[dataText.split('|')[1]];
                            //    setTimeout(function () { comp.cashoutMessageTerminalActive = 0; }, 3000);
                            //    setTimeout(function () { comp.cashOutButtonClick = 0; }, 3000);
                            //    setTimeout(function () { comp.confirmMessageActive = 0 }, 3000);
                            //    //comp.confirmMessageActive = 0
                            //    setTimeout(function () { comp.cashoutmessageTerminal = "" }, 3000);

                            //    //comp.cashOutMessage = "Başarısız";
                            //    console.log("errorcode");
                            // });
                            comp.coreService.CloseCashoutWaitingModal();
                        } else if (dataText.split('|')[0] == 'success') {
                            //comp.isCashOut = true;

                            //setTimeout(function() {
                            //    $('#cashoutdetail_creditvoucheropenbetsCd')
                            //        .modal({
                            //            detachable: false,
                            //        })
                            //        .modal('show');
                            //}, 1000);

                            setTimeout(function() {
                                comp.coreService.configureClient();
                            }, 2000);

                            comp.getCashOutValueRefresh_Terminal();
                            comp.coreService.CloseCashoutWaitingModal();
                            try {
                                comp.Message_Modal_Header = 'INFO';
                                comp.Message_Modal_Desc = 'Cashout Successful';

                                $('#Message_Modal').modal('show');

                                setTimeout(function() {
                                    $('#Message_Modal').modal('hide');
                                    setTimeout(function() {
                                        window.history.back();
                                    }, 0);
                                }, 3000);
                            } catch (e) {
                                // Modal açılamazsa doğrudan geri dön
                                setTimeout(function() {
                                    window.history.back();
                                }, 0);
                            }
                        } else {
                            comp.isCashOut = false;
                            console.log('error');
                            comp.coreService.CloseCashoutWaitingModal();
                        }
                    }
                    comp.withdrawDimmer = '';
                    // entry.IsLoading = false;
                },
                function(error) {
                    comp.coreService.CloseCashoutWaitingModal();
                    console.log('Error happened', error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );

        // console.log("CashOutValue", CashOutValue);
        // console.log("SlipId", this.idforcahsout);

        // this.http.get(this.apisUrl + '/CashoutDetail/' + langId + '/' + e + '/' + timeZone)
        //    .pipe(map((response: Response) => <SlipModel[]>response).subscribe(res => {
        //        this.cashOutDetailList = res;});
    }

    public payoutSlipPay(a) {
        if (this.payoutPayConfirmButton == 1) {
            const options = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/x-www-form-urlencoded',
                }),
                observe: 'response' as 'body',
            };

            const comp = this as TournamentsService;
            const urlParams = new URLSearchParams();
            urlParams.append('__RequestVerificationToken', a);
            urlParams.append('TicketNumber', this.PayoutSlipNumber);

            urlParams.append('TicketPassword', this.PayoutSlipPassword);
            const body = urlParams.toString();

            this.responseString = '';
            return this.http
                .post<any>(this.apisUrl + 'Bets_Payout_Control', body, options)
                .toPromise()
                .then(data => {
                    const dataText = data.body.Data;
                    console.log(dataText);
                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        if (dataText.result == '1') {
                            comp.getPayoutModal();
                            comp.readPayoutErrorVisible = 0;
                            comp.readPayoutError = '';

                            return '';
                        } else if (dataText.result == '2') {
                            // comp.isWithdrawMessage = true;

                            comp.getPayoutModal();
                            comp.readPayoutErrorVisible = 0;
                            comp.readPayoutError = '';
                            return '';
                        } else if (dataText.result == '3') {
                            comp.readPayoutErrorVisible = 1;
                            comp.readPayoutError = comp.translateStaticWord(
                                'This_coupon_cannot_be_paid_on_this_terminal',
                            );
                            comp.PayoutSlipNumber = '';
                            comp.PayoutSlipPassword = '';
                            return comp.translateStaticWord('This_coupon_cannot_be_paid_on_this_terminal');
                        } else {
                            comp.readPayoutErrorVisible = 1;
                            comp.readPayoutError = comp.translateStaticWord('Coupons_Didnt_Found');
                            comp.PayoutSlipNumber = '';
                            comp.PayoutSlipPassword = '';
                            return comp.translateStaticWord('Coupons_Didnt_Found');
                        }
                    }
                    // comp.PayoutSlipNumber = "";
                    // comp.PayoutSlipPassword = "";
                    // entry.IsLoading = false;
                });

            // this.http.get(this.apisUrl + '/CashoutDetail/' + langId + '/' + e + '/' + timeZone)
            //    .pipe(map((response: Response) => <SlipModel[]>response).subscribe(res => {
            //        this.cashOutDetailList = res;});
        } else {
            $('#SlipControlModal')
                .modal({
                    allowMultiple: true,
                    closable: false,
                })
                .modal('show');
        }
    }

    public PayoutSlipPay_Confirm(a, Amount, CurrencyId, SlipId) {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
            responseType: 'text' as 'text',
        };

        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('SlipId', SlipId);
        urlParams.append('Amount', Amount);

        urlParams.append('CurrencyId', CurrencyId);
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'Payout_State_Pay', body, options) // ...using post request
            .subscribe(
                function(data) {
                    const dataText = data.toString();

                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        if (dataText.split('|')[0] != '172') {
                            comp.updatePayoutModal();
                        } else {
                            console.log('Kupon Yanlış');
                            this.PayoutSlipNumber = '';
                            this.PayoutSlipPassword = '';
                        }
                    }
                    // entry.IsLoading = false;
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );
    }

    public getPayoutModal() {
        return this.http
            .get(this.apisUrl + '/PayoutDetail/' + this.PayoutSlipNumber + '/' + timeZone + '/' + langId)
            .pipe(map((response: Response) => (response as unknown) as LastPayoutModel[]))
            .subscribe(res => {
                this.payoutModalList = res;
                if (this.payoutModalList.length != 0) {
                    // $('#PayoutDetailModal').modal('show');

                    $('#PayoutDetailModal')
                        .modal('setting', 'closable', false)
                        .modal('show');

                    // $('#ReadPayoutSlip').css("display", "none !important");
                    // position: inherit;

                    // $('#ReadPayoutSlip').modal('hide');
                    this.PayoutPayConfirm = this.translateStaticWord('Payment_Successful');
                }
            });
    }

    public updatePayoutModal() {
        return this.http
            .get(this.apisUrl + '/PayoutDetail/' + this.PayoutSlipNumber + '/' + timeZone + '/' + langId)
            .pipe(map((response: Response) => (response as unknown) as LastPayoutModel[]))
            .subscribe(res => {
                this.payoutModalList = res;
                this.PayoutSlipNumber = '';
                this.PayoutSlipPassword = '';
                this.PayoutPayConfirmVisible = 1;
                this.PayoutPayConfirm = this.translateStaticWord('Payment_Successful');
            });
    }

    public RestoreSlip_Terminal(SlipId, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('langId', langId);
        urlParams.append('SlipId', this.SlipCashOutSlipNumber.toString());

        const slipstring = JSON.stringify(this.slipCurrents);
        urlParams.append('currentslip', slipstring);

        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'BettingSlipEditor_Insert_From_BetsDetailWindow_Restore', body, { headers }) // ...using post request
            .subscribe(
                function(data: any) {
                    comp.slipCurrents = data;
                    localStorage.setItem('currentslip', JSON.stringify(this.slipCurrents));
                    comp.changeSlipAmount(comp.amount, comp.BettingSlip_Menu_SlipType);

                    comp.Update_CurrentSlip();
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );
    }

    public RestoreSlip_Terminal_Bet(a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('langId', langId);
        urlParams.append('SlipId', this.rsbSlipId.toString());
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'BettingSlipEditor_Insert_From_BetsDetailWindow_Restore', body, { headers }) // ...using post request
            .subscribe(
                function(data: any) {
                    comp.slipCurrents = data;
                    localStorage.setItem('currentslip', JSON.stringify(this.slipCurrents));
                    comp.getSelectedOdds();
                    comp.getCurrentSlip();

                    comp.changeSlipAmount(comp.amount, comp.BettingSlip_Menu_SlipType);
                    // comp.Update_CurrentSlip();
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );
    }

    public vorabTicket_Terminal(SlipId, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('langId', langId);
        urlParams.append('SlipId', SlipId.toString().replace('Ö', '').replace(',', ''));

        const slipstring = JSON.stringify(this.slipCurrents);
        urlParams.append('currentslip', slipstring);

        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'VorabTicket_Terminal', body, { headers })
            .subscribe(
                function(data: any) {
                    if (data && data.betslip && Array.isArray(data.betslip)) {
                        comp.slipCurrents = data.betslip;

                        const slipInfo = data.info[0];

                        // slipInfo içeriği API'den geldiği için fake data kullanılmıyor.
                        // Sadece currencyId EUR (4) ise sistem slip işlemleri yapılır.
                        if (slipInfo.CurrencyId === 4) {
                            // BettingSlip_Menu'da System tab'ına tıkla
                            setTimeout(() => {
                                const systemTabElement = document.querySelector('#BettingSlip_Menu a:nth-child(3)') as HTMLElement;
                                if (systemTabElement) {
                                    systemTabElement.click();
                                }
                            }, 50);

                            // Sistem kombinasyonlarını yükle
                            comp.getSystemSlips();

                             // SlipStatu alanı ile sistem kombinasyonlarını işaretle
                             if (slipInfo.SlipStatu && slipInfo.SlipStatu.trim() !== '') {
                                 // SlipStatu: "3,4" gibi geliyor
                                 const statusNumbers = slipInfo.SlipStatu.split(',').map(num => parseInt(num.trim(), 10) - 1);
                                 console.log('SlipStatu:', slipInfo.SlipStatu);
                                 console.log('Status Numbers (0-based):', statusNumbers);

                                setTimeout(() => {
                                    console.log('SystemSlips length:', comp.systemSlips.length);
                                    console.log('isClicked array:', comp.isClicked);
                                    
                                    // isClicked array'i yoksa başlat
                                    if (!comp.isClicked || comp.isClicked.length === 0) {
                                        comp.isClicked = new Array(comp.systemSlips.length).fill(false);
                                        console.log('Initialized isClicked array:', comp.isClicked);
                                    }

                                    // SystemModalButtonValueArray'i temizle
                                    comp.SystemModalButtonValueArray = [];

                                    // Her kombinasyon için direkt olarak işaretle
                                    statusNumbers.forEach(index => {
                                        console.log(`Processing index: ${index}`);
                                        if (index >= 0 && index < comp.systemSlips.length) {
                                            comp.isClicked[index] = true;
                                            comp.SystemModalButtonValueArray[index] = `${index + 1}/${comp.systemSlips.length}`;
                                            console.log(`Marked combination ${index + 1} as selected`);
                                        }
                                    });
                                    
                                    // SystemModalButtonValue display text'ini güncelle
                                    if (comp.SystemModalButtonValueArray.length > 0) {
                                        comp.SystemModalButtonValue = comp.translateStaticWord('System') + ' ' + 
                                            comp.SystemModalButtonValueArray.filter(item => item != null).join(',');
                                        console.log('Updated SystemModalButtonValue:', comp.SystemModalButtonValue);
                                    }
                                }, 200); // Sistem sliplerinin yüklenmesi için bekle
                            }
                        }

                        localStorage.setItem('currentslip', JSON.stringify(comp.slipCurrents));
                        
                        console.log('VorabTicket Amount', data.amount);
                        // VorabTicket Amount değerini stake olarak set et
                        if (data.amount && data.amount > 0) {
                            comp.amount = data.amount;
                            console.log('Setting amount to:', comp.amount);
                            
                            // Calculator Modal değerlerini set et
                            comp.CalculatorValue = data.amount;
                            
                            // CalculatorModal_Ok mantığını uygula
                            setTimeout(() => {
                                comp.changeSlipAmount(
                                    ((Number(comp.CalculatorValue) * 100) / (100 + comp.tax)).toFixed(4),
                                    comp.BettingSlip_Menu_SlipType
                                );
                            }, 200);
                        }
                        
                        // Slip'i güncelle
                        comp.Update_CurrentSlip();
                        
                        // Başarı mesajı göster
                        comp.messageType = 'successMessage';
                        comp.message = new translatePipe().transform('VorabTicketSuccess');
                    } else {
                        comp.messageType = 'errorMessage';
                        comp.message = new translatePipe().transform('VorabTicketNotFound');
                    }
                },
                function(error) {
                    console.log('VorabTicket Error happened: ' + error);
                    comp.responseString = 'error|System Error';
                    comp.messageType = 'errorSystemMessage';
                    comp.message = new translatePipe().transform('VorabTicketError');
                },
                function() {},
            );
    }

    public Update_CurrentSlip() {
        return;
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

        // this.http.get(this.apisUrl + "/CurrentSlip");
        return this.http
            .get(this.apisUrl + '/CurrentSlip/')
            .pipe(map((response: Response) => (response as unknown) as SlipModel[]))
            .subscribe(res => {});
    }

    public getsendCashOut_Terminal(CashOutValue, SlipId, a, Percent = '') {
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('LangId', langId);
        urlParams.append('CashOutValue', CashOutValue);
        urlParams.append('stakeFraction', Percent);

        urlParams.append('SlipId', this.SlipCashOutSlipNumber.toString());
        urlParams.append('IsJacktime', this._uiHelper.terminalConfig.IsJacktimeActive.toString());
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'CashOutPay_Terminal', body, RESPONSE_AS_TEXT_X_WWW) // ...using post request
            .subscribe(
                data => {
                    const dataText = data['body'].toString();

                    if (dataText == '') {
                        comp.coreService.CloseCashoutWaitingModal();
                        return 'error|System Error';
                    } else {
                        if (dataText.split('|')[0] == 'error') {
                            comp.cashoutmessageTerminal = dataText.split('|')[1];
                            setTimeout(function() {
                                comp.cashoutMessageTerminalActive = 0;
                            }, 3000);
                            setTimeout(function() {
                                comp.cashOutButtonClick = 0;
                            }, 3000);
                            setTimeout(function() {
                                comp.confirmMessageActive = 0;
                            }, 3000);

                            setTimeout(function() {
                                comp.cashoutmessageTerminal = '';
                            }, 3000);
                            // comp.cashOutMessage = "Başarısız";
                            // comp.isWithdrawMessage = true;
                            comp.isCashOut = false;
                            console.log('error');
                            comp.coreService.CloseCashoutWaitingModal();
                        } else if (dataText.split('|')[0] == 'errorcode') {
                            // comp.isWithdrawMessage = true;
                            comp.isCashOut = false;
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.cashoutmessageTerminal = result[dataText.split('|')[1]];
                                setTimeout(function() {
                                    comp.cashoutMessageTerminalActive = 0;
                                }, 3000);
                                setTimeout(function() {
                                    comp.cashOutButtonClick = 0;
                                }, 3000);
                                setTimeout(function() {
                                    comp.confirmMessageActive = 0;
                                }, 3000);
                                // comp.confirmMessageActive = 0
                                setTimeout(function() {
                                    comp.cashoutmessageTerminal = '';
                                }, 3000);

                                // comp.cashOutMessage = "Başarısız";
                                console.log('errorcode');
                            });
                            comp.coreService.CloseCashoutWaitingModal();
                        } else if (dataText.split('|')[0] == 'success') {
                            // comp.isWithdrawMessage = true;
                            comp.isCashOut = true;
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.cashoutmessageTerminal = result[dataText.split('|')[1]];
                                comp.coreService.configureClient();
                                comp.SlipNumberControl = 0;
                                comp.SlipCashOutSlipPasswordControl = 0;

                                setTimeout(function() {
                                    comp.cashoutMessageTerminalActive = 0;
                                }, 1000);
                                setTimeout(function() {
                                    comp.cashOutButtonClick = 0;
                                }, 1000);
                                // comp.confirmMessageActive = 0;

                                setTimeout(function() {
                                    comp.confirmMessageActive = 0;
                                }, 1000);
                                // Başarı sonrası bilgi modali göster, 3 saniye sonra kapat ve geri dön
                                try {
                                    comp.Message_Modal_Header = 'INFO';
                                    comp.Message_Modal_Desc = 'Cashout Successful';

                                    $('#Message_Modal').modal('show');

                                    setTimeout(function() {
                                        $('#Message_Modal').modal('hide');
                                        setTimeout(function() {
                                            window.history.back();
                                        }, 0);
                                    }, 3000);
                                } catch (e) {
                                    // Modal açılamazsa doğrudan geri dön
                                    setTimeout(function() {
                                        window.history.back();
                                    }, 0);
                                }
                                // setTimeout(function () { $('#cashoutdetail_creditvoucher').modal('show'); }, 1000);
                                // setTimeout(function() {
                                //     $('#cashoutdetail_creditvoucher')
                                //         .modal({
                                //             allowMultiple: true,
                                //             // closable: false
                                //         })
                                //         .modal('show');
                                // }, 1000);
                                // comp.cashOutMessage = "Başarılı";
                                // console.log("success");
                                // setTimeout(function () {
                                //    $('#modalopencash')
                                //        .modal('hide all')
                                //        .modal('refresh')
                                //        .modal("hide")
                                // }, 2000);
                            });
                            comp.coreService.CloseCashoutWaitingModal();
                        } else {
                            comp.isCashOut = false;
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.cashoutmessageTerminal = result[dataText.split('|')[1]];
                                setTimeout(function() {
                                    comp.cashoutMessageTerminalActive = 0;
                                }, 3000);
                                setTimeout(function() {
                                    comp.cashOutButtonClick = 0;
                                }, 3000);
                                setTimeout(function() {
                                    comp.confirmMessageActive = 0;
                                }, 3000);
                                // comp.confirmMessageActive = 0
                                setTimeout(function() {
                                    comp.cashoutmessageTerminal = '';
                                }, 3000);

                                // comp.cashOutMessage = "Başarısız";
                                console.log('errorcode');
                            });
                            comp.coreService.CloseCashoutWaitingModal();
                        }
                        this.getCashoutDetail_Terminal();
                        this.isCashoutConfirmStage = false;
                    }
                    comp.withdrawDimmer = '';
                    // entry.IsLoading = false;
                },
                error => {
                    comp.coreService.CloseCashoutWaitingModal();
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                    this.isCashoutConfirmStage = false;
                },
                function() {},
            );

        console.log('CashOutValue', CashOutValue);
        console.log('SlipId', this.idforcahsout);

        // this.http.get(this.apisUrl + '/CashoutDetail/' + langId + '/' + e + '/' + timeZone)
        //    .pipe(map((response: Response) => <SlipModel[]>response).subscribe(res => {
        //        this.cashOutDetailList = res;});
    }

    public getsendPayout_Terminal(PayoutValue, SlipId, a) {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
            responseType: 'text' as 'text',
        };
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('LangId', langId);
        urlParams.append('PayoutValue', PayoutValue);
        urlParams.append('SlipId', this.SlipCashOutSlipNumber.toString());
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'WonSlipPayout_Terminal', body, options) // ...using post request
            .subscribe(
                function(data) {
                    const dataText = data['body'];
                    console.log('Payout', data, dataText);
                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        if (dataText.split('|')[0] == 'error') {
                            comp.payOutMessage = dataText.split('|')[1];
                            // comp.cashOutMessage = "Başarısız";
                            // comp.isWithdrawMessage = true;
                            comp.isPayOut = false;
                            console.log('error');

                            setTimeout(function() {
                                comp.payOutButtonClick = 0;
                            }, 3000);
                            comp.confirmMessageActivePayout = 0;
                            // setTimeout(function () { comp.cashoutmessageTerminal = "" }, 3000);
                        } else if (dataText.split('|')[0] == 'errorcode') {
                            // comp.isWithdrawMessage = true;
                            comp.isPayOut = false;
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.payOutMessage = result[dataText.split('|')[1]];
                                // comp.cashOutMessage = "Başarısız";
                                setTimeout(function() {
                                    comp.payOutButtonClick = 0;
                                }, 3000);
                                comp.confirmMessageActivePayout = 0;
                                console.log('errorcode');
                            });
                        } else if (dataText.split('|')[0] == 'success') {
                            // comp.isWithdrawMessage = true;
                            comp.isPayOut = true;
                            comp.coreService.configureClient();
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.payOutMessage = result[dataText.split('|')[1]];
                                comp.coreService.configureClient();
                                // comp.cashOutMessage = "Başarılı";

                                comp.SlipNumberControl = 0;
                                comp.SlipCashOutSlipPasswordControl = 0;

                                setTimeout(function() {
                                    comp.payOutButtonClick = 0;
                                }, 1000);
                                // comp.confirmMessageActive = 0;
                                comp.confirmMessageActivePayout = 0;

                                // setTimeout(function() {
                                //     $('#cashoutdetail_creditvoucher').modal('show');
                                // }, 1000);
                            });
                        }
                    }
                    comp.withdrawDimmer = '';
                    // entry.IsLoading = false;
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );

        console.log('PayoutValue', PayoutValue);

        // this.http.get(this.apisUrl + '/CashoutDetail/' + langId + '/' + e + '/' + timeZone)
        //    .pipe(map((response: Response) => <SlipModel[]>response).subscribe(res => {
        //        this.cashOutDetailList = res;});
    }

    public getSlip(e) {
        return this.http
            .get(this.apisUrl + '/slips/' + langId + '/' + e + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as SlipModel[]));
    }

    public getOpenSlipDetail(e) {
        return this.http.get(this.apisUrl + '/SlipDetail/' + langId + '/' + e + '/' + timeZone).pipe(
            map((response: Response) => (response as unknown) as SlipModel[]),
            finalize(() =>
                $('#modalopenbets')
                    .modal('hide all')
                    .modal({ observeChanges: true })
                    .modal('refresh')
                    .modal('show'),
            ),
        );
    }

    public getCompletedSlipDetail(e) {
        return this.http.get(this.apisUrl + '/SlipDetail/' + langId + '/' + e + '/' + timeZone).pipe(
            map((response: Response) => (response as unknown) as SlipModel[]),
            finalize(() =>
                $('#modalcompletedbets')
                    .modal('hide all')
                    .modal({ observeChanges: true })
                    .modal('refresh')
                    .modal('show'),
            ),
        );
    }

    public getSlipByDate(e, m, y) {
        if (m != undefined && y != undefined) {
            return this.http
                .get(this.apisUrl + '/slips/' + langId + '/' + e + '/' + timeZone + '/' + m + '/' + y)
                .pipe(map((response: Response) => (response as unknown) as SlipModel[]));
        } else {
            return this.http
                .get(this.apisUrl + '/slips/' + langId + '/' + e + '/' + timeZone)
                .pipe(map((response: Response) => (response as unknown) as SlipModel[]));
        }
    }

    public getSideBanners(): Promise<any> {
        return this.http
            .get(this.apisUrl + '/SideBanner/' + langId)
            .toPromise()
            .then(r => {
                return r;
            })
            .catch(error => {
                return console.warn('e', error);
            });
    }

    public getServerTime() {
        return this.http
            .get(this.apisUrl + '/ServerTime/' + timeZone)
            .pipe(map((response: Response) => response as unknown));
    }

    public getGoldenRaceURL() {
        return this.http
            .get(this.apisUrl + '/VirtualGoldenRace')
            .pipe(map((response: Response) => response as unknown));
    }

    public getGoldenRaceKenoURL() {
        return this.http
            .get(this.apisUrl + '/VirtualGoldenRaceKeno')
            .pipe(map((response: Response) => response as unknown));
    }

    public getPage(p) {
        this.pageObservable = this.http
            .get(this.apisUrl + 'Pages/' + p + '/' + langId)
            .pipe(map((response: Response) => (response as unknown) as PageModel[]));
    }

    public getTransactionType() {
        return this.http
            .get(this.apisUrl + '/TransactionTypes/' + langId)
            .pipe(map((response: Response) => (response as unknown) as TransactionTypeModel[]));
    }

    public getTransactionTypeById(id, month, year) {
        return this.http
            .get(this.apisUrl + '/Bookings/' + langId + '/' + month + '/' + id + '/' + year + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as BookingsModel[]));
    }

    getBookings(_month = 1, _year = 2019, _tid = 0, customerId = '-'): Promise<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http
            .get(`${this.apisUrl}/Bookings/${langId}/${_month}/${_tid}/${_year}/${timeZone}/${customerId}`, { headers })
            .toPromise()
            .then(r => {
                return r;
            })
            .catch(error => {
                return [];
            });
    }

    bookingLoginResult(customerId = '-'): Promise<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http
            .get(`${this.apisUrl}/BookingLoginResult/${customerId}`, { headers })
            .toPromise()
            .then(response => {
                return response;
            })
            .catch(error => {
                return [];
            });
    }

    getSlipDuplicate(SlipId = 0) {
        return this.http
            .get(this.apisUrl + 'SlipDuplicatebySlipId/' + SlipId + '/' + langId + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as SlipModel[]))
            .subscribe(res => {
                if (res.length != 0) {
                    this.printDuplicateSlip_List = res;
                    // Barcode Olusturma
                    const Barcode = '100' + SlipId + '000';

                    // setTimeout(
                    //     () =>
                    //         JsBarcode('#Slip_Duplicate_Barcode', Barcode, {
                    //             height: 64,
                    //         }),
                    //     500,
                    // );
                    // Slip Detail Getir
                    this.getSlipDuplicateDetail(SlipId);
                }
            });
    }

    public getSlipDuplicateDetail(slipId) {
        return this.http
            .get(this.apisUrl + 'BettingSlip_Print_SlipDetail/' + langId + '/' + slipId + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as SlipModel[]))
            .subscribe(res => {
                this.printSlipDetailList = res;

                setTimeout(() => Print_SlipDuplicate(), 1000);
            });
    }

    public aziaDeposit(e, __RequestVerificationToken) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', __RequestVerificationToken);
        urlParams.append('Amount', e);
        urlParams.append('LangId', langId);
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'AziaDeposit', body, { headers }) // ...using post request
            .subscribe(
                function(data) {
                    const dataText = data.toString();

                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        comp.data = dataText;
                    }
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );
    }

    public fillBanks() {
        return this.http
            .get(this.apisUrl + '/WithdrawBanks/' + langId)
            .pipe(map((response: Response) => (response as unknown) as IBank[]));
    }

    public pdxWithdraw(a, e) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        comp.withdrawDimmer = 'active';
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('pdxwithdrawnote', '');
        urlParams.append('pdxwithdrawamount', e.Amount);
        urlParams.append('pdxwithdrawname', 'selam');
        urlParams.append('pdxwithdrawaccountno', e.AccountNo);
        urlParams.append('bankId', e.BankId);
        urlParams.append('LangId', langId);
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'PdxWithdraw', body, { headers }) // ...using post request
            .subscribe(
                function(data) {
                    const dataText = data.toString();

                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        if (dataText.split('|')[0] == 'error') {
                            comp.withdrawMessage = dataText.split('|')[1];
                            comp.isWithdrawMessage = true;
                            comp.isTransfer = false;
                        } else if (dataText.split('|')[0] == 'errorcode') {
                            comp.isWithdrawMessage = true;
                            comp.isTransfer = false;
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.withdrawMessage = result[dataText.split('|')[1]];
                            });
                        } else if (dataText.split('|')[0] == 'success') {
                            comp.isWithdrawMessage = true;
                            comp.isTransfer = true;
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.withdrawMessage = result[dataText.split('|')[1]];
                            });
                        }
                    }
                    comp.withdrawDimmer = '';
                    // entry.IsLoading = false;
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );
    }

    public getCustomerOne() {
        const comp = this as TournamentsService;
        return this.http
            .get(this.apisUrl + '/CustomerOne/' + langId)
            .pipe(map((response: Response) => (response as unknown) as ICustomerOne[]));
    }

    public getUploadFilesControl() {
        const comp = this as TournamentsService;

        return this.http.get(this.apisUrl + 'UploadsFiles').pipe(map(res => res));
    }

    public getSelfLimits() {
        const comp = this as TournamentsService;
        return this.http
            .get(this.apisUrl + 'SelfLimits')
            .pipe(map((response: Response) => (response as unknown) as ISelfLimits[]));
    }

    public getDepositCepbank() {
        const comp = this as TournamentsService;
        return this.http
            .get(this.apisUrl + '/DepositCepBank/' + langId)
            .pipe(map((response: Response) => (response as unknown) as IDeposit_Cepbank[]));
    }

    public getMatchOne(matchId) {
        return this.http
            .get(this.apisUrl + '/Match/' + matchId + '/' + langId + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as FixtureModel[]));
    }

    public fillCountry() {
        return this.http
            .get(this.apisUrl + '/ComboCountry/' + langId)
            .pipe(map((response: Response) => (response as unknown) as ICountry[]));
    }

    public fillCurrency() {
        return this.http
            .get(this.apisUrl + '/Currency/' + langId)
            .pipe(map((response: Response) => (response as unknown) as ICurrency[]));
    }

    public fillPhoneCode() {
        return this.http
            .get(this.apisUrl + '/ComboPhoneNumber/' + langId)
            .pipe(map((response: Response) => (response as unknown) as IPhoneCode[]));
    }

    public fillQuestion() {
        return this.http
            .get(this.apisUrl + '/ComboPasswordQuestion/' + langId)
            .pipe(map((response: Response) => (response as unknown) as IPasswordQuestion[]));
    }

    public fillCity() {
        return this.http
            .get(this.apisUrl + '/ComboCity/' + langId)
            .pipe(map((response: Response) => (response as unknown) as ICity[]));
    }

    public fillBank() {
        return this.http
            .get(this.apisUrl + '/ComboBank/' + langId)
            .pipe(map((response: Response) => (response as unknown) as IBank[]));
    }

    public uploadFilesCreate(uploadFiles, a, docId) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        // urlParams.append('Document', uploadFiles.DocumentType);
        urlParams.append('DocumentId', docId);
        urlParams.append('LangId', langId);
        const body = urlParams.toString();
        this.responseString = '';
        this.http.post(this.apisUrl + 'UploadFiless', body, { headers }).subscribe();
    }

    public Bitcoin(a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        const body = urlParams.toString();

        this.http.post(this.apisUrl + 'GetBTCAddress', body, { headers }).subscribe(function(data) {
            const dataText = data.toString();
        });
    }

    public withDrawPerfectMoney(text, no, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('amounttext', text);
        urlParams.append('accountno', no);
        urlParams.append('LangId', langId);
        const body = urlParams.toString();

        this.http.post(this.apisUrl + 'PerfectMoneyWithdraw', body, { headers }).subscribe(
            function(data) {
                const dataText = data.toString();

                if (dataText == '') {
                    return 'error|System Error';
                } else {
                    if (dataText.split('|')[0] == 'error') {
                        comp.personalDetailMessage = dataText.split('|')[1];
                        comp.IsSavePersonalDetail = false;
                        console.log(dataText.split('|')[1]);
                    } else if (dataText.split('|')[0] == 'errorcode') {
                        $.getJSON('/lang/' + langCode + '.json', function(result) {
                            comp.personalDetailMessage = result[dataText.split('|')[1]];
                        });
                        comp.IsSavePersonalDetail = false;
                        console.log(dataText.split('|')[1]);
                    } else if (dataText.split('|')[0] == 'successcode') {
                        $.getJSON('/lang/' + langCode + '.json', function(result) {
                            comp.personalDetailMessage = result[dataText.split('|')[1]];
                            console.log(1);
                        });
                        comp.IsSavePersonalDetail = true;
                        console.log(dataText.split('|')[1]);
                    }
                }
                comp.personalDetailDimmer = '';
            },
            function(error) {
                console.log('Error happened' + error);
                this.responseString = 'error|System Error';
            },
            function() {},
        );
    }

    public IrnapalDeposit(text, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('amounttext', text);
        urlParams.append('LangId', langId);
        const body = urlParams.toString();
        this.http.post(this.apisUrl + 'IrnapalDeposit', body, { headers }).subscribe(
            function(data) {
                const dataText = data.toString();

                if (dataText == '') {
                    return 'error|System Error';
                } else {
                    if (dataText.split('|')[0] == 'error') {
                        comp.personalDetailMessage = dataText.split('|')[1];
                        comp.IsSavePersonalDetail = false;
                        console.log(dataText.split('|')[1]);
                    } else if (dataText.split('|')[0] == 'errorcode') {
                        $.getJSON('/lang/' + langCode + '.json', function(result) {
                            comp.personalDetailMessage = result[dataText.split('|')[1]];
                        });
                        comp.IsSavePersonalDetail = false;
                        console.log(dataText.split('|')[1]);
                    } else if (dataText.split('|')[0] == 'success') {
                        // $.getJSON('/lang/' + langCode + '.json', function (result) {
                        //    comp.personalDetailMessage = result[dataText.split('|')[1]];
                        //    console.log(1);
                        // });
                        // comp.IsSavePersonalDetail = true;
                        // console.log(dataText.split('|')[1]);
                        document.location.href = dataText.split('|')[1];
                    }
                }
                comp.personalDetailDimmer = '';
            },
            function(error) {
                console.log('Error happened' + error);
                this.responseString = 'error|System Error';
            },
            function() {},
        );
    }

    public ZainCashDeposit(text, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('amounttext', text);
        urlParams.append('LangId', langId);
        const body = urlParams.toString();
        this.http.post(this.apisUrl + 'ZainCashDeposit', body, { headers }).subscribe(
            function(data) {
                const dataText = data.toString();

                if (dataText == '') {
                    return 'error|System Error';
                } else {
                    if (dataText.split('|')[0] == 'error') {
                        comp.depositZainCashMessage = dataText.split('|')[1];
                        comp.isDepositZainCashForm = false;
                        console.log(dataText.split('|')[1]);
                    } else if (dataText.split('|')[0] == 'errorcode') {
                        $.getJSON('/lang/' + langCode + '.json', function(result) {
                            comp.personalDetailMessage = result[dataText.split('|')[1]];
                        });
                        comp.isDepositZainCashForm = false;
                        console.log(dataText.split('|')[1]);
                    } else if (dataText.split('|')[0] == 'success') {
                        document.location.href = dataText.split('|')[1];
                    }
                }
                comp.depositZainCashDimmer = '';
            },
            function(error) {
                console.log('Error happened' + error);
                this.responseString = 'error|System Error';
            },
            function() {},
        );
    }

    public FastPayDeposit(text, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('amounttext', text);
        urlParams.append('LangId', langId);
        const body = urlParams.toString();
        this.http.post(this.apisUrl + 'FastPayDeposit', body, { headers }).subscribe(
            function(data) {
                const dataText = data.toString();

                if (dataText == '') {
                    return 'error|System Error';
                } else {
                    if (dataText.split('|')[0] == 'error') {
                        comp.depositFastPayMessage = dataText.split('|')[1];
                        comp.isDepositFastPayForm = false;
                        console.log(dataText.split('|')[1]);
                    } else if (dataText.split('|')[0] == 'errorcode') {
                        $.getJSON('/lang/' + langCode + '.json', function(result) {
                            comp.depositFastPayMessage = result[dataText.split('|')[1]];
                        });
                        comp.isDepositFastPayForm = false;
                        console.log(dataText.split('|')[1]);
                    } else if (dataText.split('|')[0] == 'success') {
                        document.location.href = dataText.split('|')[1];
                    }
                }
                comp.depositFastPayDimmer = '';
            },
            function(error) {
                console.log('Error happened' + error);
                this.responseString = 'error|System Error';
            },
            function() {},
        );
    }

    public CoinBaseDeposit(text, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('amounttext', text);
        urlParams.append('LangId', langId);
        const body = urlParams.toString();
        this.http.post(this.apisUrl + 'CoinBaseDeposit', body, { headers }).subscribe(
            function(data) {
                const dataText = data.toString();

                if (dataText == '') {
                    return 'error|System Error';
                } else {
                    if (dataText.split('|')[0] == 'error') {
                        comp.depositCoinBaseMessage = dataText.split('|')[1];
                        comp.isDepositCoinBaseForm = false;
                        console.log(dataText.split('|')[1]);
                    } else if (dataText.split('|')[0] == 'errorcode') {
                        $.getJSON('/lang/' + langCode + '.json', function(result) {
                            comp.depositCoinBaseMessage = result[dataText.split('|')[1]];
                        });
                        comp.isDepositCoinBaseForm = false;
                        console.log(dataText.split('|')[1]);
                    } else if (dataText.split('|')[0] == 'success') {
                        document.location.href = dataText.split('|')[1];
                    }
                }
                comp.depositCoinBaseDimmer = '';
            },
            function(error) {
                console.log('Error happened' + error);
                this.responseString = 'error|System Error';
            },
            function() {},
        );
    }

    public WebMoneyWithdraw(text, no, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('amounttext', text);
        urlParams.append('accountno', no);
        urlParams.append('LangId', langId);
        const body = urlParams.toString();
        this.http.post(this.apisUrl + 'WebMoneyWithdraw', body, { headers }).subscribe(
            function(data) {
                const dataText = data.toString();

                if (dataText == '') {
                    return 'error|System Error';
                } else {
                    if (dataText.split('|')[0] == 'error') {
                        comp.personalDetailMessage = dataText.split('|')[1];
                        comp.IsSavePersonalDetail = false;
                        console.log(dataText.split('|')[1]);
                    } else if (dataText.split('|')[0] == 'errorcode') {
                        $.getJSON('/lang/' + langCode + '.json', function(result) {
                            comp.personalDetailMessage = result[dataText.split('|')[1]];
                        });
                        comp.IsSavePersonalDetail = false;
                        console.log(dataText.split('|')[1]);
                    } else if (dataText.split('|')[0] == 'successcode') {
                        console.log('T.SSSSSSSSuccess');
                        $.getJSON('/lang/' + langCode + '.json', function(result) {
                            comp.personalDetailMessage = result[dataText.split('|')[1]];
                            console.log(1);
                        });
                        comp.IsSavePersonalDetail = true;
                        console.log(dataText.split('|')[1]);
                    }
                }
                comp.personalDetailDimmer = '';
            },
            function(error) {
                console.log('Error happened' + error);
                this.responseString = 'error|System Error';
            },
            function() {},
        );
    }

    public savePersonalDetail(customerOne, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        comp.personalDetailDimmer = 'active';
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('customerName', customerOne.CustomerName);
        urlParams.append('customerSurname', customerOne.CustomerSurname);
        urlParams.append('address', customerOne.Address);
        urlParams.append('addressAdditional', customerOne.AddressAdditional);
        urlParams.append('city', customerOne.City);
        urlParams.append('countryId', customerOne.CountryId);
        urlParams.append('eMail', customerOne.Email);
        urlParams.append('phoneNumber', customerOne.PhoneNumber);
        urlParams.append('phoneCodeId', customerOne.PhoneCodeId);
        urlParams.append('passwordQuestion', customerOne.PasswordAnswer);
        urlParams.append('passwordQuestionId', customerOne.PasswordQuestionId);
        urlParams.append('oddchangehigher', customerOne.IsOddIncreasement);
        urlParams.append('oddchangelower', customerOne.IsOddDecreasements);
        urlParams.append('timeZone', timeZone);
        urlParams.append('LangId', langId);
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'SaveCustomerDetail', body, { headers }) // ...using post request
            .subscribe(
                function(data) {
                    const dataText = data.toString();

                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        if (dataText.split('|')[0] == 'error') {
                            comp.personalDetailMessage = dataText.split('|')[1];
                            comp.IsSavePersonalDetail = false;
                            console.log(dataText.split('|')[1]);
                        } else if (dataText.split('|')[0] == 'errorcode') {
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.personalDetailMessage = result[dataText.split('|')[1]];
                            });
                            comp.IsSavePersonalDetail = false;
                            console.log(dataText.split('|')[1]);
                        } else if (dataText.split('|')[0] == 'success') {
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.personalDetailMessage = result[dataText.split('|')[1]];
                                console.log(1);
                            });
                            comp.IsSavePersonalDetail = true;
                            console.log(dataText.split('|')[1]);
                        }
                    }
                    comp.personalDetailDimmer = '';
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );
    }

    ////////////////////////////////////////////////// SELF LİMİTS ////////////// SELT LİMİTS///////////////////////////////////////////// SELF LİMİTS /////////////////////
    public SaveCustomerSelfLimits(selfLimits, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        comp.selfLimitsDimmer = 'active';
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);

        urlParams.append('CustomerSelfLimitId', selfLimits.CustomerLimitId);
        urlParams.append('StakeDailyLimit', selfLimits.StakeDailyLimit);
        urlParams.append('StakeWeeklyLimit', selfLimits.StakeWeeklyLimit);
        urlParams.append('StakeMonthlyLimit', selfLimits.StakeMonthlyLimit);
        urlParams.append('DepositDailyLimit', selfLimits.DepositDailyLimit);
        urlParams.append('DepositWeeklyLimit', selfLimits.DepositWeeklyLimit);
        urlParams.append('DepositMounthlyLimit', selfLimits.DepositMonthlyLimit);
        urlParams.append('LossDailyLimit', selfLimits.LossDailyLimit);
        urlParams.append('LossWeeklyLimit', selfLimits.LossWeeklyLimit);
        urlParams.append('LossMonthlyLimit', selfLimits.LossMonthlyLimit);
        urlParams.append('LangId', langId);
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'SaveCustomerSelfLimits', body, { headers }) // ...using post request
            .subscribe(
                function(data) {
                    const dataText = data.toString();

                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        if (dataText.split('|')[0] == 'error') {
                            comp.selfLimitsMessage = dataText.split('|')[1];
                            comp.IsSaveCustomerSelfLimits = false;
                            console.log(dataText.split('|')[1]);
                        } else if (dataText.split('|')[0] == 'errorcode') {
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.selfLimitsMessage = result[dataText.split('|')[1]];
                            });
                            comp.IsSaveCustomerSelfLimits = false;
                            console.log(dataText.split('|')[1]);
                        } else if (dataText.split('|')[0] == 'success') {
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.selfLimitsMessage = result[dataText.split('|')[1]];
                                console.log(1);
                            });
                            comp.IsSaveCustomerSelfLimits = true;
                            console.log(dataText.split('|')[1]);
                        }
                    }
                    comp.selfLimitsDimmer = '';
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );
    }

    public AccountLockCustomer(accountLock, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        comp.accountLockDimmer = 'active';
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);

        urlParams.append('langId', langId);
        // urlParams.append('CustomerId', accountLock.CustomerId);
        // urlParams.append('LockDayCount', accountLock.LockDayCount);
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'AccountLockCustomer', body, { headers }) // ...using post request
            .subscribe(
                function(data) {
                    const dataText = data.toString();

                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        if (dataText.split('|')[0] == 'error') {
                            comp.accountLockMessage = dataText.split('|')[1];
                            comp.IsAccountLockCustomer = false;
                            console.log(dataText.split('|')[1]);
                        } else if (dataText.split('|')[0] == 'errorcode') {
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.accountLockMessage = result[dataText.split('|')[1]];
                            });
                            comp.IsAccountLockCustomer = false;
                            console.log(dataText.split('|')[1]);
                        } else if (dataText.split('|')[0] == 'success') {
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.accountLockMessage = result[dataText.split('|')[1]];
                                console.log(1);
                            });
                            comp.IsAccountLockCustomer = true;
                            console.log(dataText.split('|')[1]);
                        }
                    }
                    comp.accountLockDimmer = '';
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );
    }

    public addNewRegister(customerOne, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        comp.registerDimmer = 'active';
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('firstname', customerOne.CustomerName);
        urlParams.append('lastname', customerOne.CustomerSurname);
        urlParams.append('branch', customerOne.Branch);
        urlParams.append('email', customerOne.Email);
        urlParams.append('currencyId', customerOne.CurrencyId);
        urlParams.append('phone', customerOne.PhoneCode + customerOne.PhoneNumber);
        urlParams.append('ssn', customerOne.ZipCode);
        urlParams.append('username', customerOne.UserName);
        urlParams.append('password', customerOne.Password);
        urlParams.append('repassword', customerOne.RePassword);
        urlParams.append('timeZone', timeZone);
        urlParams.append('LangId', langId);
        urlParams.append('countryid', customerOne.CountryId);
        urlParams.append('birthday', customerOne.Birthday);
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post('Login/SignUp', body, { headers }) // ...using post request
            .subscribe(
                function(data) {
                    const dataText = data.toString();

                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        if (dataText.split('|')[0] == 'error') {
                            comp.registerMessage = dataText.split('|')[1];
                            comp.isSaveRegister = false;
                            console.log(dataText.split('|')[1]);
                        } else if (dataText.split('|')[0] == 'errorcode') {
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.registerMessage = result[dataText.split('|')[1]];
                            });
                            comp.isSaveRegister = false;
                            console.log(dataText.split('|')[1]);
                        } else if (dataText.split('|')[0] == 'success') {
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.registerMessage = result[dataText.split('|')[1]];
                                console.log(1);
                            });
                            comp.isSaveRegister = true;
                            console.log(dataText.split('|')[1]);
                        }
                    }
                    comp.registerDimmer = '';
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );
    }

    public changePassword(changePassword, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        comp.changePasswordDimmer = 'active';
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('changeoldpassword', changePassword.OldPassword);
        urlParams.append('changenewpassword', changePassword.NewPassword);
        urlParams.append('changenewrepassword', changePassword.RePassword);
        urlParams.append('LangId', langId);
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post('Login/ChangePassword', body, { headers }) // ...using post request
            .subscribe(
                function(data) {
                    const dataText = data.toString();

                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        if (dataText.split('|')[0] == 'error') {
                            comp.changePasswordMessage = dataText.split('|')[1];
                            comp.isChangePassword = false;
                            console.log(dataText.split('|')[1]);
                        } else if (dataText.split('|')[0] == 'errorcode') {
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.changePasswordMessage = result[dataText.split('|')[1]];
                            });
                            comp.isChangePassword = false;
                            console.log(dataText.split('|')[1]);
                        } else if (dataText.split('|')[0] == 'success') {
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.changePasswordMessage = result[dataText.split('|')[1]];
                                console.log(1);
                            });
                            comp.isChangePassword = true;
                            console.log(dataText.split('|')[1]);
                        }
                    }
                    comp.changePasswordDimmer = '';
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );
    }

    public forgotPassword(email, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        comp.registerDimmer = 'active';
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('email', email);
        urlParams.append('langId', langId);
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post('Login/ForgetPassword', body, { headers }) // ...using post request
            .subscribe(
                function(data) {
                    const dataText = data.toString();

                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        if (dataText.split('|')[0] == 'error') {
                            comp.registerMessage = dataText.split('|')[1];
                            comp.isSaveRegister = false;
                        } else if (dataText.split('|')[0] == 'errorcode') {
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.registerMessage = result[dataText.split('|')[1]];
                            });
                            comp.isSaveRegister = false;
                        } else if (dataText.split('|')[0] == 'success') {
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.registerMessage = result[dataText.split('|')[1]];
                            });
                            comp.isSaveRegister = true;
                        }
                    }
                    comp.registerDimmer = '';
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );
    }

    public recoverPassword(changePassword, s, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        comp.changePasswordDimmer = 'active';
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('recoverykey', s);
        urlParams.append('changenewpassword', changePassword.NewPassword);
        urlParams.append('changenewrepassword', changePassword.RePassword);
        urlParams.append('LangId', langId);
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post('Login/RecoveryPassword', body, { headers }) // ...using post request
            .subscribe(
                function(data) {
                    const dataText = data.toString();

                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        if (dataText.split('|')[0] == 'error') {
                            comp.changePasswordMessage = dataText.split('|')[1];
                            comp.isChangePassword = false;
                            console.log(dataText.split('|')[1]);
                        } else if (dataText.split('|')[0] == 'errorcode') {
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.changePasswordMessage = result[dataText.split('|')[1]];
                            });
                            comp.isChangePassword = false;
                            console.log(dataText.split('|')[1]);
                        } else if (dataText.split('|')[0] == 'success') {
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.changePasswordMessage = result[dataText.split('|')[1]];
                                console.log(1);
                            });
                            comp.isChangePassword = true;
                            console.log(dataText.split('|')[1]);
                        }
                    }
                    comp.changePasswordDimmer = '';
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );
    }

    public mailConfirm(s, l, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        comp.changePasswordDimmer = 'active';
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('confirmkey', s);
        urlParams.append('LangId', l);
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post('Login/MailConfirm', body, { headers }) // ...using post request
            .subscribe(
                function(data) {
                    const dataText = data.toString();

                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        if (dataText.split('|')[0] == 'error') {
                            comp.changePasswordMessage = dataText.split('|')[1];
                            comp.isChangePassword = false;
                            console.log(dataText.split('|')[1]);
                        } else if (dataText.split('|')[0] == 'errorcode') {
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.changePasswordMessage = result[dataText.split('|')[1]];
                            });
                            comp.isChangePassword = false;
                            console.log(dataText.split('|')[1]);
                        } else if (dataText.split('|')[0] == 'success') {
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.changePasswordMessage = result[dataText.split('|')[1]];
                                console.log(1);
                            });
                            comp.isChangePassword = true;
                            console.log(dataText.split('|')[1]);
                        }
                    }
                    comp.changePasswordDimmer = '';
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );
    }

    public changeCasinoSubMenu(e) {
        const comp = this as TournamentsService;
        comp.isCasinoLoadingActive = 'active';
        return this.http.get(this.apisUrl + 'CasinoGames/' + e).pipe(
            map((response: Response) => (response as unknown) as CasinoModel[]),
            finalize(() => (comp.isCasinoLoadingActive = '')),
        );
    }

    public listImage(e) {
        return this.http
            .get(this.apisUrl + 'Landing/' + e)
            .pipe(map((response: Response) => (response as unknown) as LandingModel[]));
    }

    public fillSlider() {
        return this.http
            .get(this.apisUrl + '/Slider/' + langId)
            .pipe(map((response: Response) => (response as unknown) as ISlider[]));
    }

    public getLiveUpcoming() {
        this.liveUpcomingObservable = this.http
            .get(this.apisUrl + '/LiveUpcomingFixture/' + langId + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as FixtureModel[]));
    }

    public changeSelectedSlipCurrent(enable, banko, oddId, __RequestVerificationToken) {
        const _odd = this.slipCurrents.filter(s => s.OddId1 == oddId);

        if (_odd != undefined && _odd.length > 0) {
            console.warn(_odd);
            _odd[0].Enable = enable;
            _odd[0].Banko = banko;
        }

        const slipstring = JSON.stringify(this.slipCurrents);
        localStorage.setItem('currentslip', slipstring);
        this.slipCurrents = JSON.parse(localStorage.getItem('currentslip'));
        this.getCurrentSlip();
    }

    public sendDeposit_Cepbank(deposit_Cepbank, a) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        comp.depositCepBankDimmer = 'active';
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('bankid', deposit_Cepbank.BankId);
        urlParams.append('receiverphone', deposit_Cepbank.PhoneReceiver);
        urlParams.append('senderphone', deposit_Cepbank.PhoneSender);
        urlParams.append('refno', deposit_Cepbank.ReferenceNo);
        urlParams.append('pin', deposit_Cepbank.Password);
        urlParams.append('ssn', deposit_Cepbank.SSNNO);
        urlParams.append('place', deposit_Cepbank.Place);
        urlParams.append('amountval', deposit_Cepbank.Amount);
        urlParams.append('birthdate', '01/01/1990');
        urlParams.append('senderssn', '123456789101');

        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'CustomerDepositCepBank', body, { headers }) // ...using post request
            .subscribe(
                function(data) {
                    const dataText = data.toString();

                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        if (dataText.split('|')[0] == 'error') {
                            comp.depositCepBankMessage = dataText.split('|')[1];
                            comp.isDepositCepBankForm = false;
                            console.log(dataText.split('|')[1]);
                        } else if (dataText.split('|')[0] == 'errorcode') {
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.depositCepBankMessage = result[dataText.split('|')[1]];
                            });
                            comp.isDepositCepBankForm = false;
                            console.log(dataText.split('|')[1]);
                        } else if (dataText.split('|')[0] == 'success') {
                            $.getJSON('/lang/' + langCode + '.json', function(result) {
                                comp.depositCepBankMessage = result[dataText.split('|')[1]];
                                console.log(1);
                            });
                            comp.isDepositCepBankForm = true;
                            console.log(dataText.split('|')[1]);
                        }
                    }
                    comp.depositCepBankDimmer = '';
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );
    }

    // sendDeposit_AsiaHawala(tid, amount, a) {
    //    let bodyString = JSON.stringify("");
    //    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    //    let options = new RequestOptions({ headers: headers });
    //    let comp = <TournamentsService>this;
    //    comp.depositAsiaHawalaDimmer = "active";
    //    let urlParams = new URLSearchParams();
    //    urlParams.append('__RequestVerificationToken', a);
    //    urlParams.append('amounttext', amount);
    //    urlParams.append('LangId', langId);

    //    let body = urlParams.toString()

    //    this.responseString = "";
    //    this.http.post(this.apisUrl + "AsiaHawala", body, options)
    //         .subscribe(function (data) {
    // const dataText = data.toString();

    //            if (dataText == '') {
    //                return "error|System Error";
    //            }
    //            else {
    //                if (dataText.split('|')[0] == "error") {
    //                    comp.depositAsiaHawalaMessage = dataText.split('|')[1];
    //                    comp.isDepositAsiaHawalaForm = false;
    //                    console.log(dataText.split('|')[1]);
    //                }
    //                else if (dataText.split('|')[0] == "errorcode") {
    //                    $.getJSON('/lang/' + langCode + '.json', function (result) {
    //                        comp.depositAsiaHawalaMessage = result[dataText.split('|')[1]];
    //                    });
    //                    comp.isDepositAsiaHawalaForm = false;
    //                    console.log(dataText.split('|')[1]);
    //                }
    //                else if (dataText.split('|')[0] == "success") {

    //                    let asiahawala = <AsiaHawala>tid;
    //                    tid.transactionid = dataText.split('|')[1];

    //                    console.log("tid", tid);

    //                    comp.isDepositAsiaHawalaForm = true;

    //                }
    //            }
    //            comp.depositAsiaHawalaDimmer = "";
    //        },
    //            function (error) { console.log("Error happened" + error); this.responseString = "error|System Error"; },
    //            function () { });
    // }
    public getTaxRate(): void {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        let resTaxRate;
        this.http.get('/Login/GetTaxRate', { headers }).subscribe(val => {
            resTaxRate = val.toString();
            // console.log('Tax Rate', resTaxRate);
            this.tax = Number(resTaxRate);
        });
    }

    // BettingSlip_PrintSlip_Cashout
    public getPrintSlip_Cashout(slipId) {
        return this.http
            .get(this.apisUrl + '/BettingSlip_PrintSlip_Cashout/' + langId + '/' + slipId + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as SlipModel[]))
            .subscribe(res => {
                this.printSlip_Cashout_List = res;
                // console.log("RES", res);
                const comp = this as TournamentsService;

                // Barcode Olusturma
                const Barcode = '100' + slipId + '000';

                setTimeout(
                    () =>
                        JsBarcode('#PrintSlip_Cashout_Barcode', Barcode, {
                            height: 64,
                        }),
                    500,
                );

                // Slip Detail Getir
                comp.getBettingSlip_Cashout_SlipDetail(slipId);
            });
    }

    public getPrintLastSlip() {
        return this.http
            .get(this.apisUrl + '/BettingSlip_PrintLastSlip/' + langId + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as SlipModel[]))
            .subscribe(res => {
                if (res.length != 0) {
                    this.printLastSlip_List = res;
                    // console.log("RES", res);
                    const comp = this as TournamentsService;

                    // Barcode Olusturma
                    const Barcode = '100' + this.printLastSlip_List[0].SlipId + '000';

                    setTimeout(
                        () =>
                            JsBarcode('#Print_LastSlip_Barcode', Barcode, {
                                height: 64,
                            }),
                        500,
                    );

                    // Slip Detail Getir
                    this.getBettingSlip_LastSlipDetail(this.printLastSlip_List[0].SlipId);
                } else {
                    $('#LastSlipControlModal').modal('show');
                }
            });
    }

    public getPrintLastSlipByParameter(slipID, password) {
        return this.http
            .get<any>(
                this.apisUrl +
                    '/BettingSlip_PrintLastSlip_byParamater/' +
                    slipID +
                    '/' +
                    password +
                    '/' +
                    langId +
                    '/' +
                    timeZone,
            )
            .toPromise()
            .then(res => {
                if (res.Data && res.Data.fail == 1) {
                    return 'fail';
                } else {
                    if (res.length != 0) {
                        this.printLastSlip_List = res;
                        // console.log("RES", res);
                        const comp = this as TournamentsService;

                        // Barcode Olusturma
                        const Barcode = '100' + this.printLastSlip_List[0].SlipId + '000';

                        setTimeout(
                            () =>
                                JsBarcode('#Print_LastSlip_Barcode', Barcode, {
                                    height: 64,
                                }),
                            500,
                        );

                        // Slip Detail Getir
                        this.getBettingSlip_LastSlipDetail(this.printLastSlip_List[0].SlipId);
                    } else {
                        $('#LastSlipControlModal').modal('show');
                    }
                    return 'success';
                }
            });
    }

    // SON PAYOUT KUPONU
    public getPrintLastSlipDetail(__RequestVerificationToken) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;

        const TerminalBalance = comp.coreService.customerUser.TerminalBalance;

        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', __RequestVerificationToken);

        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'getLastSlipDetail', body, { headers }) // ...using post request
            .subscribe(
                function(data) {
                    const dataText = data.toString();

                    if (dataText == '') {
                        return 'error|System Error';
                    } else {
                        const currentdate = new Date();
                        comp.LSTicketDate =
                            currentdate.getDate() +
                            '.' +
                            (currentdate.getMonth() + 1) +
                            '.' +
                            currentdate.getFullYear() +
                            '  ' +
                            currentdate.getHours() +
                            ':' +
                            currentdate.getMinutes() +
                            ':' +
                            currentdate.getSeconds();

                        const createdDate = new Date().toLocaleString();

                        comp.LSBranchId = dataText.split('|')[0];
                        comp.LSParentBranchId = dataText.split('|')[1];

                        comp.LSTicketNo = dataText.split('|')[3];
                        comp.LSAmount = dataText.split('|')[4];
                        comp.LSTicketPassword = dataText.split('|')[5];

                        // Barcode Olusturma
                        const Barcode = '20000' + comp.LSTicketNo + comp.LSTicketPassword;

                        setTimeout(
                            () =>
                                JsBarcode('#Last_Payout_Detail_Barcode', Barcode, {
                                    height: 64,
                                }),
                            100,
                        );

                        setTimeout(() => Print_LastPayout_Detail_Ticket(), 500);
                    }
                },
                function(error) {
                    console.log('Error happened' + error);
                    this.responseString = 'error|System Error';
                },
                function() {},
            );
    }

    public getCustomerTransaction(TransactionType, Date) {
        return this.http
            .get(this.apisUrl + '/CustomerTransactionDetail/' + TransactionType + '/' + Date + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as CustomerTransactionModel[]))
            .subscribe(res => {
                const comp = this as TournamentsService;
                this.customerTransactionList = res;
            });
    }

    public getCustomerBets(SlipState, Date) {
        return this.http
            .get(this.apisUrl + '/CustomerBetsDetail/' + SlipState + '/' + Date + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as CustomerBetsModel[]))
            .subscribe(res => {
                const comp = this as TournamentsService;
                this.CustomerBetsList = res;
            });
    }

    public getBettingSlip_LastSlipDetail(slipId) {
        return this.http
            .get(this.apisUrl + '/BettingSlip_Print_SlipDetail/' + langId + '/' + slipId + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as SlipModel[]))
            .subscribe(res => {
                const comp = this as TournamentsService;
                this.printSlipDetailList = res;

                setTimeout(() => Print_LastSlipTicket(), 500);
            });
    }

    public getPrintLastPayout() {
        return this.http
            .get(this.apisUrl + '/BettingSlip_PrintLastPayout/' + langId + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as LastPayoutModel[]))
            .subscribe(res => {
                if (res.length != 0) {
                    this.printLastPayout_List = res;
                    // console.log("RES", res);
                    const comp = this as TournamentsService;

                    // Barcode Olusturma
                    const Barcode = '100' + this.printLastPayout_List[0].SlipId + '000';

                    // setTimeout(() => JsBarcode("#Print_LastPayout_Barcode", Barcode, {
                    //    height: 64
                    // }), 500);

                    // Slip Detail Getir
                    // this.getBettingSlip_LastPayoutDetail(this.printLastPayout_List[0].SlipId);

                    setTimeout(() => Print_LastPayoutTicket(), 500);
                } else {
                    $('#LastPayoutControlModal').modal('show');
                }
            });
    }

    public getBettingSlip_LastPayoutDetail(slipId) {
        return this.http
            .get(this.apisUrl + '/BettingSlip_Print_SlipDetail/' + langId + '/' + slipId + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as SlipModel[]))
            .subscribe(res => {
                const comp = this as TournamentsService;
                this.printSlipDetailList = res;

                setTimeout(() => Print_LastPayoutTicket(), 500);
            });
    }

    public getBettingSlip_Cashout_SlipDetail(slipId) {
        return this.http
            .get(this.apisUrl + '/BettingSlip_Print_SlipDetail/' + langId + '/' + slipId + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as SlipModel[]))
            .subscribe(res => {
                const comp = this as TournamentsService;
                this.printSlipDetailList = res;

                setTimeout(() => Print_Cashout_Ticket(), 500);
            });
    }

    public getPrintSlip(slipId) {
        this.rsbSlipId = slipId;
        return this.http
            .get(this.apisUrl + '/BettingSlip_PrintSlip/' + langId + '/' + slipId + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as SlipModel[]))
            .subscribe(res => {
                // this.printSlipList = res;
                //// console.log("RES", res);
                // let comp = <TournamentsService>this;
                // console.log("Ticket_Password", this.printSlipList[0].TicketPassword);
                //// $('#PrintSlip_Modal').modal('show');

                //// Barcode Olusturma
                // let Barcode = "100" + slipId + this.printSlipList[0].TicketPassword;

                // setTimeout(() => JsBarcode("#PrintSlip_Barcode", Barcode, {
                //    height: 64
                // }), 500);

                //// Slip Detail Getir
                // comp.getBettingSlip_SlipDetail(slipId);
                const TerminalId = this.coreService.customerUser.TerminalId;
                _sendChromeMessage({
                    command: 'printslip',
                    slipid: slipId,
                    langid: langId,
                    timezone: timeZone,
                    terminalid: TerminalId,
                });
                this._uiHelper.SendElectronMessage('printSlip', {
                    command: 'printslip',
                    slipid: slipId,
                    langid: langId,
                    timezone: timeZone,
                    terminalid: TerminalId,
                });
            });
    }

    public getPrintSlipTemp(slipId) {
        this.rsbSlipId = slipId;

        const TerminalId = this.coreService.customerUser.TerminalId;
        _sendChromeMessage({
            command: 'printslip',
            slipid: slipId,
            langid: langId,
            timezone: -1,
            terminalid: TerminalId,
        });
        this._uiHelper.SendElectronMessage('printSlip', {
            command: 'printslip',
            slipid: slipId,
            langid: langId,
            timezone: -1,
            terminalid: TerminalId,
        });
        return 1;
    }

    public getBettingSlip_SlipDetail(slipId) {
        /*return this.http.get(this.apisUrl + '/BettingSlip_Print_SlipDetail/' + langId + '/' + slipId + '/' + timeZone)
.pipe(map((response: Response) => <SlipModel[]>response).subscribe(res => {
let comp = <TournamentsService>this;
this.printSlipDetailList = res;

setTimeout(() => Print_Ticket(), 500);

}
);*/
    }

    public getSlipDetail_Terminal() {
        this.clear_SlipDetail_Cashout_Counter();
        return this.http
            .get(
                this.cashoutApisUrl +
                    '/SlipDetailTerminal2/' +
                    langId +
                    '/' +
                    this.SlipCashOutSlipNumber +
                    '/' +
                    timeZone,
            )
            .pipe(map((response: Response) => (response as unknown) as SlipModel[]))
            .subscribe(res => {
                //this.SlipDetailList_Terminal = res;
                const cashoutFilter = {
                    slipdetailslist: res,
                    cashOutValueList_Terminal: this.cashOutValueList_Terminal,
                };
                const workerCashoutData = this._webWorkerService
                    .run(this.mergeCashoutValues, cashoutFilter)
                    .then(result => {
                        this.SlipDetailList_Terminal = result;
                    })
                    .catch(err => {
                        console.log('cashout workerLiveData error', err);
                    });
                SetLanguage('', '');
            });
    }

    public getSlipDetailRefresh_Terminal() {
        if (this.SlipDetailTerminal_Completed) {
            this.SlipDetailTerminal_Completed = false;
            return this.http
                .get(
                    this.cashoutApisUrl +
                        '/SlipDetailTerminal2/' +
                        langId +
                        '/' +
                        this.SlipCashOutSlipNumber +
                        '/' +
                        timeZone,
                )
                .pipe(map((response: Response) => (response as unknown) as SlipModel[]))
                .subscribe(res => {
                    //this.SlipDetailList_Terminal = res;

                    const cashoutFilter = {
                        slipdetailslist: res,
                        cashOutValueList_Terminal: this.cashOutValueList_Terminal,
                    };
                    const workerCashoutData = this._webWorkerService
                        .run(this.mergeCashoutValues, cashoutFilter)
                        .then(result => {
                            this.SlipDetailList_Terminal = result;
                        })
                        .catch(err => {
                            console.log('cashout workerLiveData error', err);
                        });
                    SetLanguage('', '');
                    this.SlipDetailTerminal_Completed = true;
                });
        }
    }

    // OLD 14.01.2022 de Kapatıldı
    public getCashoutDetail_Terminal_OLD() {
        console.log('CustomerId', this.coreService.customerUser.CustomerId);
        this.clear_SlipDetail_Cashout_Counter();
        return this.http
            .get(this.apisUrl + '/CashoutDetailTerminal/' + langId + '/' + this.SlipCashOutSlipNumber + '/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as CashOutModelTerminal[]))
            .subscribe(res => {
                this.CashoutDetailList_Terminal = res;
                SetLanguage('', '');
            });
    }

    // OLD 14.01.2022 de Kapatıldı
    public getCashoutDetailRefresh_Terminal_OLD() {
        if (this.CashoutDetailTerminal_Completed) {
            this.CashoutDetailTerminal_Completed = false;
            return this.http
                .get(
                    this.apisUrl +
                        '/CashoutDetailTerminal/' +
                        langId +
                        '/' +
                        this.SlipCashOutSlipNumber +
                        '/' +
                        timeZone,
                )
                .pipe(map((response: Response) => (response as unknown) as CashOutModelTerminal[]))
                .subscribe(res => {
                    this.CashoutDetailList_Terminal = res;
                    SetLanguage('', '');
                    this.CashoutDetailTerminal_Completed = true;
                });
        }
    }

    public getCashoutDetail_Terminal() {
        this.clear_SlipDetail_Cashout_Counter();
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', $('input[name="__RequestVerificationToken"]').val());
        urlParams.append('LangId', langId);
        urlParams.append('TimeZone', timeZone);
        urlParams.append('SlipId', this.SlipCashOutSlipNumber.toString());
        urlParams.append('CustomerId', this.coreService.customerUser.CustomerId);
        urlParams.append('TerminalId', this.coreService.customerUser.TerminalId);
        urlParams.append('Username', this.coreService.customerUser.UserName);
        const body = urlParams.toString();
        return this.http
            .post(this.cashoutApisUrl + 'CashoutDetailTerminal3', body, { headers })
            .pipe(map((response: Response) => (response as unknown) as CashOutModelTerminal[]))
            .subscribe(res => {
                this.CashoutDetailList_Terminal = res;
                SetLanguage('', '');
            });
    }

    public getCashoutDetailRefresh_Terminal() {
        if (this.CashoutDetailTerminal_Completed) {
            this.CashoutDetailTerminal_Completed = false;

            const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
            const comp = this as TournamentsService;
            const urlParams = new URLSearchParams();
            urlParams.append('__RequestVerificationToken', $('input[name="__RequestVerificationToken"]').val());
            urlParams.append('LangId', langId);
            urlParams.append('TimeZone', timeZone);
            urlParams.append('SlipId', this.SlipCashOutSlipNumber.toString());
            urlParams.append('CustomerId', this.coreService.customerUser.CustomerId);
            urlParams.append('Username', this.coreService.customerUser.UserName);

            const body = urlParams.toString();
            return this.http
                .post(this.cashoutApisUrl + 'CashoutDetailTerminal3', body, { headers })
                .pipe(map((response: Response) => (response as unknown) as CashOutModelTerminal[]))
                .subscribe(res => {
                    this.CashoutDetailList_Terminal = res;
                    SetLanguage('', '');
                    this.CashoutDetailTerminal_Completed = true;
                });
        }
    }

    public getCashOutValue_Terminal() {
        this.clear_SlipDetail_Cashout_Counter();
        this.http
            .get(
                this.cashoutApisUrl +
                    '/CashoutValueTerminal2/' +
                    langId +
                    '/' +
                    this.SlipCashOutSlipNumber +
                    '/' +
                    timeZone +
                    '/' +
                    this._uiHelper.terminalConfig.IsJacktimeActive,
            )
            .pipe(map((response: Response) => (response as unknown) as CashOutModelTerminal[]))
            .subscribe(res => {
                this.cashOutValueList_Terminal = res;
                //this.mergeCashoutValues();
                // console.warn(this.cashOutValueList_Terminal);
                SetLanguage('', '');
            });
    }

    public getCashOutValueRefresh_Terminal() {
        if (this.CashoutDetailTerminalValue_Completed) {
            this.CashoutDetailTerminalValue_Completed = false;
            try {
                this.http
                    .get(
                        this.cashoutApisUrl +
                            '/CashoutValueTerminal2/' +
                            langId +
                            '/' +
                            this.SlipCashOutSlipNumber +
                            '/' +
                            timeZone +
                            '/' +
                            this._uiHelper.terminalConfig.IsJacktimeActive,
                    )
                    .pipe(map((response: Response) => (response as unknown) as CashOutModelTerminal[]))
                    .subscribe(res => {
                        this.cashOutValueList_Terminal = res;
                        //this.mergeCashoutValues();
                        SetLanguage('', '');
                        this.CashoutDetailTerminalValue_Completed = true;
                    });
                this.getCashoutDetailRefresh_Terminal();
            } catch (e) {
                this.CashoutDetailTerminalValue_Completed = true;
            }
        }
    }

    // Ticket Password Control

    public isCashoutConfirmStage = false;
    public ticket_Slip_Password_Control(SlipId, Password) {
        // return this.http.get(this.apisUrl + '/Ticket_Slip_Password_Control/' + SlipId + '/' + Password + '/' + langId)
        //    .pipe(map((response: Response) => <SlipModel[]>response).subscribe(res => { });
        const comp = this as TournamentsService;
        this.http
            .get(
                this.apisUrl + '/Ticket_Slip_Password_Control/' + SlipId + '/' + Password + '/' + langId,
                RESPONSE_AS_TEXT_X_WWW,
            )
            .subscribe(data => {
                const dataText = data['body'].toString();
                // console.log('______data', dataText);
                if (dataText == 'error' && Password != '000') {
                    SetLanguage('', '');
                    $('#SlipControlModal')
                        .modal({
                            allowMultiple: true,
                            closable: false,
                        })
                        .modal('show');
                } else {
                    // console.log("SLIP_ID : ", SlipId);
                    comp.Reset_SlipDetail_Cashout_Counter();
                    $('#SlipControlModal').modal('hide');
                    comp.SlipCashOutSlipNumber = parseInt(SlipId);
                    comp.SlipCashOutSlipPassword = parseInt(Password);
                    if (
                        comp.SlipNumberControl != comp.SlipCashOutSlipNumber ||
                        (comp.SlipCashOutSlipPassword != comp.SlipCashOutSlipPasswordControl &&
                            comp.SlipCashOutSlipPassword != 0)
                    ) {
                        comp.cashOutButtonClick = 0;
                        comp.confirmMessageActive = 0;
                        comp.SlipCashOutSlipPasswordControl = comp.SlipCashOutSlipPassword;
                        comp.SlipNumberControl = comp.SlipCashOutSlipNumber;

                        comp.router.navigate(['/SlipDetail']);
                    } else if (
                        comp.SlipCashOutSlipNumber == comp.SlipNumberControl &&
                        comp.SlipCashOutSlipPassword == comp.SlipCashOutSlipPasswordControl &&
                        comp.cashOutButtonClick == 1 &&
                        comp.SlipCashOutSlipPassword != 0 &&
                        this.isCashoutConfirmStage === false
                    ) {
                        // cashout onaylama kısmı

                        this.isCashoutConfirmStage = true;

                        comp.confirmTicketCounter = 3;
                        comp.confirmMessageActive = 1;
                        comp.confirmTicketSetIntervalClear = setInterval(() => comp.ConfirmTicketCounter_Func(), 1000);
                    } else if (
                        comp.SlipCashOutSlipNumber == comp.SlipNumberControl &&
                        comp.SlipCashOutSlipPassword == comp.SlipCashOutSlipPasswordControl &&
                        comp.payOutButtonClick == 1 &&
                        comp.SlipCashOutSlipPassword != 0
                    ) {
                        comp.confirmTicketCounterPayout = 3;
                        comp.confirmMessageActivePayout = 1;
                        comp.confirmTicketSetIntervalClearPayout = setInterval(
                            () => comp.ConfirmTicketCounterPayout_Func(),
                            1000,
                        );
                    }
                    comp.getCashoutDetail_Terminal();
                    comp.getCashOutValue_Terminal();
                }
            });
        SetLanguage('', '');
    }

    public ConfirmTicketCounter_Func() {
        this.coreService.OpenCashoutWaitingModal();
        this.confirmTicketCounter = this.confirmTicketCounter - 1;

        if (this.confirmTicketCounter == 0) {
            // console.log('geldi');
            this.getsendCashOut_Terminal(
                this.CashOutPayAcceptValue,
                this.SlipCashOutSlipNumber,
                $('input[name="__RequestVerificationToken"]').val(),
                this.PayoutNow,
            );

            clearInterval(this.confirmTicketSetIntervalClear);
            this.cashoutMessageTerminalActive = 1;
        }
    }

    public ConfirmTicketCounterPayout_Func() {
        this.confirmTicketCounterPayout = this.confirmTicketCounterPayout - 1;

        if (this.confirmTicketCounterPayout == 0) {
            console.log('geldi');
            this.getsendPayout_Terminal(
                this.PayoutPayAcceptValue,
                this.SlipCashOutSlipNumber,
                $('input[name="__RequestVerificationToken"]').val(),
            );

            clearInterval(this.confirmTicketSetIntervalClearPayout);
            // this.cashoutMessageTerminalActive = 1;
        }
    }

    public Terminal_Balance_Change(Amount, Type, __RequestVerificationToken) {
        if (Type == 'increase') {
            const options = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/x-www-form-urlencoded',
                }),
                observe: 'response' as 'body',
                responseType: 'text' as 'text',
            };

            const comp = this as TournamentsService;

            const TerminalBalance = comp.coreService.customerUser.TerminalBalance;

            const urlParams = new URLSearchParams();
            urlParams.append('__RequestVerificationToken', __RequestVerificationToken);
            urlParams.append('Amount', Amount);
            urlParams.append('Type', Type);
            urlParams.append('TerminalBalance', TerminalBalance);
            const body = urlParams.toString();

            this.responseString = '';
            this.http
                .post(this.apisUrl + 'Terminal_Balance_Change', body, options) // ...using post request
                .subscribe(
                    function(data) {
                        // console.log("Gelen cevap : ",data);
                        const dataText = data.toString();

                        if (dataText == '') {
                            setTimeout(function() {
                                comp.Terminal_Balance_Change(Amount, Type, __RequestVerificationToken);
                            }, 1500);
                            //return 'error|System Error';
                        } else {
                            // comp.coreService.configureClient();
                            //todo: electron money check
                            if (Type == 'increase') {
                                comp.coreService.configureClient();
                            }
                        }
                    },
                    function(error) {
                        setTimeout(function() {
                            comp.Terminal_Balance_Change(Amount, Type, __RequestVerificationToken);
                        }, 1500);
                        //console.log('Error happened' + error);
                        //this.responseString = 'error|System Error';
                    },
                    function() {},
                );
        } else {
            const comp = this as TournamentsService;

            const TerminalBalance = comp.coreService.customerUser.TerminalBalance;

            const urlParams = new URLSearchParams();
            urlParams.append('__RequestVerificationToken', __RequestVerificationToken);

            const body = urlParams.toString();

            this.responseString = '';
            this.http
                .post(this.apisUrl + 'Terminal_Information', body, RESPONSE_AS_TEXT_X_WWW) // ...using post request
                .subscribe(
                    function(data) {
                        const dataText = data['body'].toString();
                        console.log(dataText, data);

                        if (dataText == '') {
                            return 'error|System Error';
                        } else {
                            const TerminalId = dataText.split('|')[0];
                            const Username = dataText.split('|')[1];
                            const CurrencyId = dataText.split('|')[2];
                            const CurrencyCode = dataText.split('|')[3];
                            const ParentBranchId = dataText.split('|')[4];
                            const CustomerId = dataText.split('|')[5];
                            _sendChromeMessage({
                                command: 'printpayout',
                                amount: Amount,
                                token: '1fe686d5d0e244c58190a872c1724114',
                                terminalid: TerminalId,
                                username: Username,
                                currencyid: CurrencyId,
                                langid: langId,
                                currencycode: CurrencyCode,
                                parentbranchid: ParentBranchId,
                                timezone: timeZone,
                                customerid: CustomerId,
                            });

                            //Silinecek
                            console.warn({
                                command: 'printpayout',
                                amount: Amount,
                                token: '1fe686d5d0e244c58190a872c1724114',
                                terminalid: TerminalId,
                                username: Username,
                                currencyid: CurrencyId,
                                langid: langId,
                                currencycode: CurrencyCode,
                                parentbranchid: ParentBranchId,
                                timezone: timeZone,
                                customerid: CustomerId,
                            });

                            comp._uiHelper.SendElectronMessage('payout', {
                                command: 'printpayout',
                                amount: Amount,
                                token: '1fe686d5d0e244c58190a872c1724114',
                                terminalid: TerminalId,
                                username: Username,
                                currencyid: CurrencyId,
                                langid: langId,
                                currencycode: CurrencyCode,
                                parentbranchid: ParentBranchId,
                                timezone: timeZone,
                                customerid: CustomerId,
                            });

                            setTimeout(function() {
                                comp.coreService.configureClient();
                            }, 3000);
                            setTimeout(function() {
                                comp.coreService.configureClient();
                            }, 5000);

                            comp.customertransactionButtonControl = 1;
                            // comp.coreService.configureClient();
                        }
                    },
                    function(error) {
                        console.log('Error happened' + error);
                        this.responseString = 'error|System Error';
                    },
                    function() {},
                );
        }
        $('#PayoutModal').modal('hide');
    }

    public Terminal_Balance_Change_Electron(Amount, Type, transaction_id, __RequestVerificationToken) {
        if (Type == 'increase') {
            const options = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/x-www-form-urlencoded',
                }),
                observe: 'response' as 'body',
                responseType: 'text' as 'text',
            };

            const comp = this as TournamentsService;

            const TerminalBalance = comp.coreService.customerUser.TerminalBalance;

            const urlParams = new URLSearchParams();
            urlParams.append('__RequestVerificationToken', __RequestVerificationToken);
            urlParams.append('Amount', Amount);
            urlParams.append('Type', Type);
            urlParams.append('TerminalBalance', TerminalBalance);
            urlParams.append('tid', transaction_id);
            const body = urlParams.toString();

            this.responseString = '';
            this.http
                .post(this.apisUrl + 'Terminal_Balance_Change_tid', body, options) // ...using post request
                .subscribe(
                    function(data) {
                        // console.log("Gelen cevap : ",data);
                        const dataText = data.toString();

                        if (dataText == '') {
                            setTimeout(function() {
                                comp.Terminal_Balance_Change(Amount, Type, __RequestVerificationToken);
                            }, 1500);
                            //return 'error|System Error';
                        } else {
                            //todo: electron money check
                            comp.coreService.configureClient();

                            comp._uiHelper.SendElectronMessage('electronListener', {
                                type: 'money_check',
                                transaction_id: transaction_id,
                                money: Amount,
                            });
                        }
                    },
                    function(error) {
                        setTimeout(function() {
                            comp.Terminal_Balance_Change_Electron(
                                Amount,
                                Type,
                                transaction_id,
                                __RequestVerificationToken,
                            );
                        }, 1500);
                        //console.log('Error happened' + error);
                        //this.responseString = 'error|System Error';
                    },
                    function() {},
                );
        }
        $('#PayoutModal').modal('hide');
    }

    public getSettingPassword_Terminal(a, passwordValueSend) {
        const comp = this as TournamentsService;
        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', a);
        urlParams.append('Password', passwordValueSend);
        const body = urlParams.toString();

        this.responseString = '';
        this.http
            .post(this.apisUrl + 'GetSettingPassword', body, RESPONSE_AS_TEXT_X_WWW) // ...using post request
            .subscribe(function(data) {
                const dataText = data['body'].toString();

                if (dataText === 'success') {
                    comp.settingPasswordError = '';
                    comp.SettingPasswordErrorVisible = 0;
                    comp.KeyboardValue = '';

                    $('#settingPassword_Modal').modal('hide');
                    $('#Terminal_Keyboard_Modal').modal('hide');
                    $('#SettingPasswordModalLogin').modal('hide');
                    // $('#settingTerminal_Modal').modal("show");

                    $('#settings_Modal_2')
                        .modal('setting', 'closable', false)
                        .modal('show');
                } else {
                    comp.settingPasswordError = 'Password is incorrect!';
                    comp.SettingPasswordErrorVisible = 1;
                    comp.KeyboardValue = '';
                }
            });
    }

    public getCloseCashBox_Terminal() {
        const comp = this as TournamentsService;
        this.http
            .get(this.apisUrl + '/CloseCashboxWindowSelectedYes/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as CashBoxModelTerminal[]))
            .subscribe(res => {
                comp.closeCahBoxList = res;
                SetLanguage('', '');
                if (comp.closeCahBoxList != null) {
                    comp.getCloseCashBoxBranch_Terminal();
                }
            });
    }

    public getCheckCashBoxDate_Terminal(startdate, enddate) {
        const comp = this as TournamentsService;
        this.http
            .get(
                this.apisUrl + '/CheckCashboxDateTerminal/' + timeZone + '/' + startdate + '/' + enddate + '/' + langId,
            )
            .pipe(map((response: Response) => (response as unknown) as CashBoxModelTerminal[]))
            .subscribe(res => {
                comp.checkCashBoxList = res;
                SetLanguage('', '');
                if (comp.checkCashBoxList != null) {
                    comp.getCheckCashBoxDateBranch_Terminal();
                }
            });
    }

    public getCheckCashBoxDateBranch_Terminal() {
        const comp = this as TournamentsService;
        this.http
            .get(this.apisUrl + '/CloseCashboxWindowSelectedBranch/' + timeZone + '/' + langId)
            .pipe(map((response: Response) => (response as unknown) as CashBoxModel))
            .subscribe(res => {
                this.checkCashBoxBranch = res;
                SetLanguage('', '');
                if (comp.checkCashBoxBranch != null) {
                    // $('#CheckCashBoxDateModal').modal('show');
                }
            });
    }

    public getCheckCashBox_Terminal() {
        const comp = this as TournamentsService;
        this.http
            .get(this.apisUrl + '/CheckCashboxTerminal/' + timeZone + '/' + langId)
            .pipe(map((response: Response) => (response as unknown) as CashBoxModelTerminal[]))
            .subscribe(res => {
                comp.checkCashBoxList = res;
                SetLanguage('', '');
                if (comp.checkCashBoxList != null) {
                    comp.getCheckCashBoxBranch_Terminal();
                }
            });
    }

    public getCheckCashBoxBranch_Terminal() {
        const comp = this as TournamentsService;
        this.http
            .get(this.apisUrl + '/CloseCashboxWindowSelectedBranch/' + timeZone + '/' + langId)
            .pipe(map((response: Response) => (response as unknown) as CashBoxModel))
            .subscribe(res => {
                this.checkCashBoxBranch = res;
                SetLanguage('', '');
                if (comp.checkCashBoxBranch != null) {
                    // $('#CheckCashBoxModal').modal('show');
                }
            });
    }

    public getCloseCashBoxBranch_Terminal() {
        const comp = this as TournamentsService;
        this.http
            .get(this.apisUrl + '/CloseCashboxWindowSelectedBranch/' + timeZone)
            .pipe(map((response: Response) => (response as unknown) as CashBoxModel))
            .subscribe(res => {
                this.closeCashBoxBranch = res;
                SetLanguage('', '');
                if (comp.closeCashBoxBranch != null) {
                    $('#closeCashBoxModal').modal('show');
                }
            });
    }

    public getBranchWinList() {
        return this.http.get(this.apisUrl + '/ProcBranchWinList');
    }

    public setActiveSortTypeOfLive(e) {
        this.activeSortTypeOfLive = e;
        this._uiHelper.changeSportFixtureSort.emit(true);
    }

    // getTerminalInfo(__RequestVerificationToken) {
    //    let bodyString = JSON.stringify(""); // Stringify payload
    //    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }); // ... Set content type to JSON
    //    let options = new RequestOptions({ headers: headers }); // Create a request option
    //    let comp = <TournamentsService>this;

    //    let TerminalBalance = comp.coreService.customerUser.TerminalBalance;

    //    let urlParams = new URLSearchParams();
    //    urlParams.append('__RequestVerificationToken', __RequestVerificationToken);
    //    let body = urlParams.toString()

    //    this.responseString = "";
    //    this.http.post(this.apisUrl + "Terminal_Info", body, {headers}) // ...using post request
    //         .subscribe(function (data) {
    // const dataText = data.toString();

    //            if (dataText == '') {
    //                return "error|System Error";
    //            }
    //            else {
    //                comp.Terminal_ID = dataText.split('|')[0];
    //                comp.Terminal_Version = dataText.split('|')[1];

    //            }
    //        },
    //        function (error) { console.log("Error happened" + error); this.responseString = "error|System Error"; },
    //        function () { });
    // }

    public getTerminalInfo() {
        const comp = this as TournamentsService;
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
            responseType: 'text' as 'text',
        };

        this.http.get(this.apisUrl + '/Terminal_Info', options).subscribe(
            function(data) {
                const dataText = data['body'];

                if (dataText == '') {
                    return 'error|System Error';
                } else {
                    if (dataText.indexOf('<html>') > -1) {
                        Sentry.captureMessage('terminalinfoerror');
                        comp._uiHelper.SendElectronMessage('electronListener', {
                            type: 'internetconnection',
                            status: false,
                            tid: this.titleService.getTitle(),
                        });
                    } else {
                        comp.Terminal_ID = dataText.split('|')[0];
                        comp.Terminal_Version = dataText.split('|')[1];
                    }
                }
            },
            error => {
                console.error(error);
                this._uiHelper.SendElectronMessage('electronListener', {
                    type: 'internetconnection',
                    status: false,
                    tid: this.titleService.getTitle(),
                });
            },
        );
        SetLanguage('', '');
    }

    public getTerminalInfo4Electron() {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
            responseType: 'text' as 'text',
        };
        return this.http.get(this.apisUrl + '/Terminal_Info', options);
    }

    public translateStaticWord(e) {
        if (translationobj != undefined) {
            const strTr = translationobj[e];
            return strTr;
        }
    }

    public clear_Betting_Slip_RestoreCounter() {
        SetLanguage('', '');
        this.rsbCounterVisible = 0;
        $('#BettingSlip_CountDown_Dimmer').dimmer('hide');
    }

    public clear_SlipDetail_Cashout_Counter() {
        // if (this.slipdetail_subClientCO != undefined) {
        //  this.slipdetail_subClientCO.unsubscribe();
        // }

        // slipdetail.ts
        clearInterval(this.timer_slipdetail);
        this.timer_slipdetail = null;

        // cashoutdetail.ts
        clearInterval(this.timer_cashoutvalue);
        this.timer_cashoutvalue = null;

        this.SlipDetailList_Terminal = [];
        this.CashoutDetailList_Terminal = [];
    }

    public Reset_SlipDetail_Cashout_Counter() {
        clearInterval(this.timer_slipdetail);
        this.timer_slipdetail = null;

        if (this.slipdetail_subClientCO != undefined) {
            this.slipdetail_subClientCO.unsubscribe();
        }
        this.timer_slipdetail = timer(500, 12000);
        this.slipdetail_subClientCO = this.timer_slipdetail.subscribe(t => this.getSlipDetailRefresh_Terminal());

        clearInterval(this.timer_cashoutvalue);
        this.timer_cashoutvalue = null;

        this.isCashOut = null;
        this.isPayOut = null;
        if (this.cashoutdetail_subClientCO != undefined) {
            this.cashoutdetail_subClientCO.unsubscribe();
        }
        this.timer_cashoutvalue = timer(12000, 12000);
        this.cashoutdetail_subClientCO = this.timer_cashoutvalue.subscribe(t => this.getCashOutValueRefresh_Terminal());
    }

    public openBets_Timer() {
        this.cleanOpenBets_Timer();

        this.timeropenbets = timer(100, 10000);
        this.openBets_subClientCO = this.timeropenbets.subscribe(t => this.getOpenBets_Refresh());
    }

    public cleanOpenBets_Timer() {
        clearInterval(this.timeropenbets);
        this.timeropenbets = null;

        if (this.openBets_subClientCO != undefined) {
            this.openBets_subClientCO.unsubscribe();
        }
    }

    public getClientConfig() {
        return this.http.get(this.apisUrl + 'GetClientSetting');
    }

    public terminalUpdateIsAnonymousBet(isAnonymousBet) {
        const comp = this as TournamentsService;
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
            responseType: 'text' as 'text',
        };
        return this.http
            .get(`${this.apisUrl}/TerminalUpdateIsAnonymousBet/${isAnonymousBet}`, options)
            .toPromise()
            .then(data => {
                const dataText = data['body'].toString();
                comp.coreService.configureClient();
                return dataText;
            });
        SetLanguage('', '');
    }

    public getTermialActiveStatus() {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
            responseType: 'text' as 'text',
        };
        return this.http
            .get(`Login/GetTermialActiveStatus`, options)
            .toPromise()
            .then(data => {
                const dataText = data['body'].toString();

                if (dataText != '' && dataText != null && dataText != undefined) {
                    return Number(dataText);
                } else {
                    return -1;
                }
            });
        SetLanguage('', '');
    }

    public getQrRewardGui() {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http
            .get(`API/QrRewardGui`, { responseType: 'text' })
            .toPromise()
            .then(r => {
                return r;
            })
            .catch(e => {
                return e;
            });
    }

    // public postQrSave(qrCode, TerminalId) {
    //     const urlParams = new URLSearchParams();
    //     urlParams.append('qrCode', qrCode);
    //     urlParams.append('TerminalId', TerminalId);
    //     const body = urlParams.toString();
    //     const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    //     return this.http
    //         .post('API/CreateRewardAppQRCode', body, { headers })
    //         .toPromise()
    //         .then(response => {
    //             // let responseData: any;
    //             // responseData = JSON.parse(response as string);
    //             return response;
    //         })
    //         .catch(error => {
    //             return 'error';
    //         });
    // }

    public procBranchQrControlResult() {
        const comp = this as TournamentsService;
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
            responseType: 'json' as 'json',
        };
        return this.http
            .get(`${this.apisUrl}/ProcBranchQrControlResult`, options)
            .toPromise()
            .then(data => {
                const jsonObject = JSON.parse(JSON.stringify(data['body']));
                return jsonObject;
            });
        SetLanguage('', '');
    }

    public ProcCustomerBarcodeSearchTerminalResult(barcode = '', isBarcodeCard = false) {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
            responseType: 'json' as 'json',
        };
        return this.http
            .get(`${this.apisUrl}ProcCustomerBarcodeSearchTerminalResult/${barcode}`, options)
            .toPromise()
            .then(data => {
                const jsonObject = JSON.parse(JSON.stringify(data['body']));

                let modalData = {
                    ResultCode: jsonObject.ResultCode,
                    CustomerId: jsonObject.CustomerId,
                    IsFirst: jsonObject.IsFirst,
                    Barcode: barcode,
                    IsBarcodeCard: isBarcodeCard,
                };
                this._uiHelper.SetBarcodeCardData(modalData);
                this._uiHelper.OpenBarcodeCardModal();
                return jsonObject;
            });
        SetLanguage('', '');
    }

    public ProcCustomerBarcodePINChangeResult(barcode = '', oldPIN = 0, newPIN = 0) {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
            responseType: 'json' as 'json',
        };
        return this.http
            .get(`${this.apisUrl}ProcCustomerBarcodePINChangeResult/${barcode}/${oldPIN}/${newPIN}`, options)
            .toPromise()
            .then(data => {
                const jsonObject = JSON.parse(JSON.stringify(data['body']));
                return jsonObject;
            });
        SetLanguage('', '');
    }

    public ProcCustomerBarcodeLoginResult(barcode = '', PIN = 0) {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
            responseType: 'json' as 'json',
        };
        return this.http
            .get(`${this.apisUrl}ProcCustomerBarcodeLoginResult/${barcode}/${PIN}`, options)
            .toPromise()
            .then(data => {
                const jsonObject = JSON.parse(JSON.stringify(data['body']));
                return jsonObject;
            });
        SetLanguage('', '');
    }

    public DecryptString(text = '') {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
            responseType: 'json' as 'json',
        };

        const urlParams = new URLSearchParams();
        urlParams.append('text', text);
        const body = urlParams.toString();
        return this.http
            .post(`${this.apisUrl}DecryptString`, body, options)
            .toPromise()
            .then(data => {
                const jsonObject = JSON.parse(JSON.stringify(data['body']));
                return jsonObject;
            });
        SetLanguage('', '');
    }

    private mergeCashoutValues = e => {
        let slipdetailslist = e.slipdetailslist;
        let cashOutValueList_Terminal = e.cashOutValueList_Terminal;

        slipdetailslist.map(_slipItem => {
            const _data = cashOutValueList_Terminal.filter(
                x =>
                    x.MatchId === _slipItem.MatchId &&
                    x.OddType == _slipItem.OddsType &&
                    x.Outcome == _slipItem.Outcomes,
            );
            // .filter(x => x.OddType == _slipItem.OddsType)
            // .filter(x => x.Outcome == _slipItem.Outcomes);
            //console.warn(_data);
            if (_data != undefined && _data.length > 0) {
                //IsActive
                _slipItem['IsActive'] = _data[0].IsActive;

                //ResultStatus
                let statecolor = _data[0].IsWon;
                if (statecolor == undefined) {
                    statecolor = _slipItem.StateColor;
                    _slipItem['ResultStatus'] = statecolor;
                } else {
                    statecolor = _slipItem.StateColor;
                    statecolor == 'visible' ? 'green' : _slipItem.StateColor;
                    _slipItem['ResultStatus'] = statecolor;
                }

                //LockStatus
                if (_data[0].Reason != undefined && _data[0].Reason != null && _data[0].Reason != '') {
                    // console.log("REASON---",_data);
                    _slipItem['LockStatus'] = _data[0].Reason;
                } else {
                    _slipItem['LockStatus'] = '';
                }

                //MatchTime
                _slipItem['MatchTime'] = _data[0].MatchTime;

                //EvenDate
                _slipItem['EvenDate'] = _data[0].EvenDate;

                //ColorStatus
                if (_data[0].IsActive && _data[0].Reason != 'Verloren') {
                    _slipItem['ColorStatus'] = true;
                } else if (_data[0].Reason == 'Verloren') {
                    _slipItem['ColorStatus'] = false;
                } else {
                    _slipItem['ColorStatus'] = _data[0].IsActive;
                }

                // Bet Placement ( Bahis oynandığı andaki Score ve Dakika )
                _slipItem['BetPlacement'] = _data[0].OddValue;

                //BetStopReasonHome
                let bId = _data[0].BetStopReasonId;
                _slipItem['BetStopReasonHome'] = '';
                _slipItem['BetStopReasonAway'] = '';
                if (
                    bId == 1 ||
                    bId == 2 ||
                    bId == 4 ||
                    bId == 6 ||
                    bId == 9 ||
                    bId == 20 ||
                    bId == 88 ||
                    bId == 83 ||
                    bId == 18
                ) {
                    _slipItem['BetStopReasonHome'] = _data[0].BetStopReason;
                }
                //BetStopReasonAway
                if (bId == 5 || bId == 7 || bId == 10 || bId == 21 || bId == 89 || bId == 19) {
                    _slipItem['BetStopReasonAway'] = _data[0].BetStopReason;
                }
                //BetStopReasonColor
                _slipItem['BetStopReasonColor'] = '';
                if (
                    bId == 2 ||
                    bId == 6 ||
                    bId == 20 ||
                    bId == 88 ||
                    bId == 7 ||
                    bId == 21 ||
                    bId == 89 ||
                    bId == 18 ||
                    bId == 19 ||
                    bId == 83
                ) {
                    _slipItem['BetStopReasonColor'] = 'red';
                } else if (bId == 5 || bId == 10 || bId == 1 || bId == 4 || bId == 9) {
                    _slipItem['BetStopReasonColor'] = 'orange';
                }
            } else {
                _slipItem['IsActive'] = true;
                _slipItem['ResultStatus'] = _slipItem.StateColor;
                _slipItem['LockStatus'] = '';
                _slipItem['MatchTime'] = '';
                _slipItem['ColorStatus'] = false;
                _slipItem['BetStopReasonHome'] = '';
                _slipItem['BetStopReasonAway'] = '';
                _slipItem['BetStopReasonColor'] = '';
                _slipItem['EvenDate'] = '';
                _slipItem['BetPlacement'] = '';
            }
        });

        return slipdetailslist;
        // console.warn(this.SlipDetailList_Terminal);
    };

    private registerOnServerEvents(): void {
        this.proxy.on('updateTerminalLiveFixture', (data: any, data2: any) => {
            const comp = this as TournamentsService;

            this._liveFixtureList = data;
            this._liveFixtureListFiltered = data;
            //this._liveFixtureListFiltered = this.rebuildLiveData(this._liveFixtureListFiltered);

            const liveFilter = {
                _data: this._liveFixtureListFiltered,
                fixturetourId: this.fixturetourId,
                sportEnum: this.sportEnum,
                sportsType: SPORTS_TYPE(),
                _olddata: this._OLDliveFixtureListFiltered,
                _slipCurrents: this.slipCurrents,
            };

            const workerLiveData = this._webWorkerService
                .run(this.rebuildLiveData, liveFilter)
                .then((result: any) => {
                    //console.log("workerLiveData",result);
                    this._uiHelper.setLiveFilteredData(result.retData);

                    this._uiHelper.SetLiveGoalListData(result.liveGoalListData);

                    this._liveFixtureListFiltered = result.retData;
                    this._OLDliveFixtureListFiltered = result.retData;

                    result.sportsType && DATA_INITIALIZER(result.sportsType).then();
                    this.slipCurrents = result._slipCurrents;
                })
                .catch(err => {
                    console.log('workerLiveData error', err);
                });

            const oddMap = {
                _oddData: data2,
                OLD_oddData: this.liveOddsList_OLD,
                forbiddenOddTypes: this._OddConstant.forbiddenOddTypes,
                _slipCurrents: this.slipCurrents,
            };
            const workerOddData = this._webWorkerService
                .run(this.rebuildLiveOdds, oddMap)
                .then(result => {
                    //console.log("workerLiveData Odd", result);
                    this.liveOddsList = result._oddData;
                    this.liveOddsList_OLD = data2;
                    this.slipCurrents = result._slipCurrents;
                    //console.warn("FlagOddChange",result._flagOddChange);
                    if (result._flagOddChange) this.changeSlipAmount(this.amount, this.slipType);
                    //console.warn(this.liveOddsList);
                })
                .catch(err => {
                    console.log('workerLiveData odd error', err);
                });
            //this.liveOddsList = this.rebuildLiveOdds(data2, this.liveOddsList_OLD);
            //this.liveOddsList_OLD = data2;

            this._liveoldSoccer = this._liveFixtureListSoccer;
            this._liveoldBasketball = this._liveFixtureListBasketball;
            this._liveoldHandball = this._liveFixtureListHandball;
            this._liveoldIceHockey = this._liveFixtureListIceHockey;
            this._liveoldTennis = this._liveFixtureListTennis;

            if (this.TerminalSearchValue == '') {
                this._liveFixtureListSoccer = data.filter(f => f.SportNameOriginal == 'Soccer');

                this._liveFixtureListTennis = data.filter(f => f.SportNameOriginal == 'Tennis');
                this._liveFixtureListHandball = data.filter(f => f.SportNameOriginal == 'Handball');
                this._liveFixtureListIceHockey = data.filter(f => f.SportNameOriginal == 'Ice Hockey');
                this._liveFixtureListBasketball = data.filter(f => f.SportNameOriginal == 'Basketball');
            } else {
                this._liveFixtureListSoccer = data.filter(
                    f =>
                        f.SportNameOriginal == 'Soccer' &&
                        (f.HomeTeam.toLowerCase().indexOf(this.TerminalSearchValue.toLowerCase()) != -1 ||
                            f.AwayTeam.toLowerCase().indexOf(this.TerminalSearchValue.toLowerCase()) != -1 ||
                            f.HomeTeam.toUpperCase().indexOf(this.TerminalSearchValue.toUpperCase()) != -1 ||
                            f.AwayTeam.toUpperCase().indexOf(this.TerminalSearchValue.toUpperCase()) != -1),
                );

                this._liveFixtureListTennis = data.filter(
                    f =>
                        f.SportNameOriginal == 'Tennis' &&
                        (f.HomeTeam.toLowerCase().indexOf(this.TerminalSearchValue.toLowerCase()) != -1 ||
                            f.AwayTeam.toLowerCase().indexOf(this.TerminalSearchValue.toLowerCase()) != -1 ||
                            f.HomeTeam.toUpperCase().indexOf(this.TerminalSearchValue.toUpperCase()) != -1 ||
                            f.AwayTeam.toUpperCase().indexOf(this.TerminalSearchValue.toUpperCase()) != -1),
                );
                this._liveFixtureListHandball = data.filter(
                    f =>
                        f.SportNameOriginal == 'Handball' &&
                        (f.HomeTeam.toLowerCase().indexOf(this.TerminalSearchValue.toLowerCase()) != -1 ||
                            f.AwayTeam.toLowerCase().indexOf(this.TerminalSearchValue.toLowerCase()) != -1 ||
                            f.HomeTeam.toUpperCase().indexOf(this.TerminalSearchValue.toUpperCase()) != -1 ||
                            f.AwayTeam.toUpperCase().indexOf(this.TerminalSearchValue.toUpperCase()) != -1),
                );
                this._liveFixtureListIceHockey = data.filter(
                    f =>
                        f.SportNameOriginal == 'Ice Hockey' &&
                        (f.HomeTeam.toLowerCase().indexOf(this.TerminalSearchValue.toLowerCase()) != -1 ||
                            f.AwayTeam.toLowerCase().indexOf(this.TerminalSearchValue.toLowerCase()) != -1 ||
                            f.HomeTeam.toUpperCase().indexOf(this.TerminalSearchValue.toUpperCase()) != -1 ||
                            f.AwayTeam.toUpperCase().indexOf(this.TerminalSearchValue.toUpperCase()) != -1),
                );
                this._liveFixtureListBasketball = data.filter(
                    f =>
                        f.SportNameOriginal == 'Basketball' &&
                        (f.HomeTeam.toLowerCase().indexOf(this.TerminalSearchValue.toLowerCase()) != -1 ||
                            f.AwayTeam.toLowerCase().indexOf(this.TerminalSearchValue.toLowerCase()) != -1 ||
                            f.HomeTeam.toUpperCase().indexOf(this.TerminalSearchValue.toUpperCase()) != -1 ||
                            f.AwayTeam.toUpperCase().indexOf(this.TerminalSearchValue.toUpperCase()) != -1),
                );
            }

            // if (this._liveFixtureListSoccer == undefined)
            // {
            //     this._liveFixtureListSoccer = data.filter(f => f.SportNameOriginal == "Soccer");
            // }
            // else
            // {
            //     //this._liveFixtureListSoccer.pipe(mergeMap(
            //     //    val => data.filter(f => f.SportNameOriginal == "Soccer")));
            // }

            // if (this._liveFixtureListSoccer == undefined) {
            //    this._liveFixtureListSoccer = data.filter(f => f.SportNameOriginal == "Soccer");
            // }
            // else {
            //    this._liveFixtureListSoccer.flatMap(
            //        val => this._liveFixtureList).subscribe(s => {
            //            data.filter(f => f.SportNameOriginal == "Soccer")

            //            console.log("Subscribe", this._liveFixtureListSoccer);
            //        });
            // }

            // console.log("LİVEFİXTURE", this._liveFixtureListSoccer);

            // console.log("_liveFixtureListBasketball", this._liveFixtureListBasketball);

            // console.log("_liveFixtureListIceHockey", this._liveFixtureListIceHockey);

            // console.log("_liveFixtureListHandball", this._liveFixtureListHandball);

            // console.log("_liveFixtureListTennis", this._liveFixtureListTennis);
        });

        this.proxy.on('updateCurrentTime', (data: any) => {
            this._terminalcurrenttime = data;
        });

        this.proxy.on('updateTerminalLiveFirstHalf', (data: any) => {
            const comp = this as TournamentsService;
            this._oldhalftimeList = this._halftimeList;

            const jsonObject = JSON.parse(JSON.stringify(data));
            this._halftimeList = jsonObject;
            this.messageReceived.emit(jsonObject);
            // this._loadingtournamentlist = false;
            // this._halftimeList = data.filter(f => f.SportNameOriginal == comp.activeSport);
            // console.log("HALFTİME", this._halftimeList);
        });

        this.proxy.on('updateTerminalLiveOdds', (data: any) => {
            this._liveeventodds = data;
            console.log(data);
        });

        // Kırmızı Kartlar için Eski Yöntem Kapatıldı ( 23.09.2021 )
        // this.proxy.on('updateCard', (data: any) => {
        //     const jsonObject = JSON.parse(JSON.stringify(data));
        //     this._cardList = jsonObject;
        //     this.messageReceived.emit(jsonObject);
        //
        //     // console.log("_cardList", jsonObject);
        //     // console.log("this._cardList", this._cardList);
        //
        //     // this._loadingtournamentlist = false;
        // });

        this.proxy.on('updateTerminalScorebox', (data: any) => {
            // this._liveFixtureList = data;
            // data =  data.filter(f => f.SportNameOriginal == comp.activeSport);
            const comp = this as TournamentsService;
            this._ScoreboxList_Old = this._ScoreboxList;

            const jsonObject = JSON.parse(JSON.stringify(data));
            this._ScoreboxList = jsonObject;
            this.messageReceived.emit(jsonObject);

            // this._ScoreboxList = data;

            // this._ScoreboxList_New = comp._ScoreboxList;

            // console.log("SCOREBOX_LIST", this._ScoreboxList);

            // if (this._ScoreboxList_Old != null) {
            //    let missing = comp._ScoreboxList_New.filter(item => comp._ScoreboxList_Old.indexOf(item) < 0);
            //    console.log("MISSING", missing); // ["e", "f", "g"]
            // }

            // this._ScoreboxList_Old = comp._ScoreboxList;
        });

        this.proxy.on('updateLiveTopScreen', (data: any) => {
            const comp = this as TournamentsService;

            this._liveTopScreenList = data;

            // console.log("TOPSCREEN_LİVE", this._liveTopScreenList);
        });

        this.proxy.on('updateUpComingTopScreen', (data: any) => {
            const comp = this as TournamentsService;

            this._upComingTopScreenList = data;

            // console.log("TOPSCREEN_UPCOMİNG ", this._upComingTopScreenList);
        });

        // İSEXPANDED DENEMESİ

        this.proxy.on('livefixtureisExpanded', (data: any) => {
            const comp = this as TournamentsService;

            this._liveisExpanded = data;

            // console.log("_liveisExpanded ", this._liveisExpanded);
        });
        this.proxy.on('uptadeNews', (data: any) => {
            const comp = this as TournamentsService;
            this._terminalnews = data;
            // console.log("NEWS", this._terminalnews);
        });
    }

    public MoneyTransaction(money) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const urlParams = new URLSearchParams();
        const TerminalId = this.coreService.customerUser.TerminalId;
        const TimeStamps = new Date();
        urlParams.append('TerminalId', TerminalId);
        urlParams.append('TimeStamps', TimeStamps.toISOString());
        urlParams.append('money', money);
        const body = urlParams.toString();
        this.http.post(this.apisUrl + 'MoneyTransactionLog', body, { headers }).subscribe(data => {
            console.log('datatatata', data);
        });
    }
}
